<template>
  <div class="q1-main c1-quiz-page" @click="c1TopTab = null">

    <!-- TOAST -->
    <transition name="qz1-toast-fade">
      <div v-if="q1Toast" class="qz1-toast" :style="{ background: q1Toast.color }">
        <svg v-if="q1Toast.icon === 'check'" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
        <svg v-else-if="q1Toast.icon === 'x'" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        <svg v-else viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        {{ q1Toast.msg }}
      </div>
    </transition>

    <div class="c1-sticky-top">
    <!-- TOP BAR -->
    <div class="c1-tib" @click="q1SlideOpen = null">
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': q1PanelActiveContent === 'viki' }"
          @click.stop="q1SelectPanel('viki')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          Quiz
        </div>
      </div>
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" :class="{ on: $route.path === '/brokers1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" :class="{ on: $route.path === '/security1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" :class="{ on: $route.path === '/quiz1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" :class="{ on: $route.path === '/instruction1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" :class="{ on: $route.path === '/settings1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" :class="{ on: $route.path === '/profile1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- TOP-STRIP TABS -->
    <div class="c1-ts-wrap" @click.stop>
      <!-- Status tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'status'}" @click.stop="c1TopTab = c1TopTab === 'status' ? null : 'status'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        <span>Status</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='status' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Result tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'result'}" @click.stop="c1TopTab = c1TopTab === 'result' ? null : 'result'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
        <span>Result</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='result' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Score tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'score'}" @click.stop="c1TopTab = c1TopTab === 'score' ? null : 'score'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
        <span>Score</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='score' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Assign tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'assign'}" @click.stop="c1TopTab = c1TopTab === 'assign' ? null : 'assign'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        <span>Assign</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='assign' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Date tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'date'}" @click.stop="c1TopTab = c1TopTab === 'date' ? null : 'date'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        <span>Date</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='date' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>
      <!-- Charts tab -->
      <div class="c1-ts-tab" :class="{on: c1TopTab === 'charts'}" @click.stop="c1TopTab = c1TopTab === 'charts' ? null : 'charts'">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
        <span>Charts</span>
        <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='charts' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
      </div>
      <div class="c1-ts-tab-sep"></div>

      <!-- Dropdowns -->
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'status'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="c1-fp-lbl" style="margin-bottom:6px;">Quiz status</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: !q1Filter.status }" @click="q1Filter.status = null">All</div>
              <div class="c1-fp-opt q1-status-active" :class="{ on: q1Filter.status === 'active' }" @click="q1Filter.status = 'active'">Active</div>
              <div class="c1-fp-opt q1-status-draft" :class="{ on: q1Filter.status === 'draft' }" @click="q1Filter.status = 'draft'">Draft</div>
              <div class="c1-fp-opt q1-status-archived" :class="{ on: q1Filter.status === 'archived' }" @click="q1Filter.status = 'archived'">Archived</div>
            </div>
            <div class="c1-fp-lbl" style="margin-top:10px;margin-bottom:6px;">Category</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: !q1Filter.category }" @click="q1Filter.category = null">All</div>
              <div v-for="cat in q1Categories" :key="cat" class="c1-fp-opt" :class="{ on: q1Filter.category === cat }" @click="q1Filter.category = cat">{{ cat }}</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'result'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="c1-fp-lbl" style="margin-bottom:6px;">My result</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: !q1Filter.result }" @click="q1Filter.result = null">All</div>
              <div class="c1-fp-opt q1-status-passed" :class="{ on: q1Filter.result === 'passed' }" @click="q1Filter.result = 'passed'">Passed</div>
              <div class="c1-fp-opt q1-status-failed" :class="{ on: q1Filter.result === 'failed' }" @click="q1Filter.result = 'failed'">Failed</div>
              <div class="c1-fp-opt q1-status-pending" :class="{ on: q1Filter.result === 'pending' }" @click="q1Filter.result = 'pending'">Pending</div>
              <div class="c1-fp-opt q1-status-not-taken" :class="{ on: q1Filter.result === 'not_taken' }" @click="q1Filter.result = 'not_taken'">Not taken</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'score'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="q1-score-range">
              <div class="q1-sr-row">
                <span class="q1-sr-lbl">Min</span>
                <input type="range" min="0" max="100" step="5" v-model.number="q1Filter.scoreMin" class="q1-range-input" />
                <span class="q1-sr-val">{{ q1Filter.scoreMin }}%</span>
              </div>
              <div class="q1-sr-row">
                <span class="q1-sr-lbl">Max</span>
                <input type="range" min="0" max="100" step="5" v-model.number="q1Filter.scoreMax" class="q1-range-input" />
                <span class="q1-sr-val">{{ q1Filter.scoreMax }}%</span>
              </div>
            </div>
            <div class="c1-fp-lbl" style="margin-top:10px;margin-bottom:6px;">Quick ranges</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 0; q1Filter.scoreMax = 100">All</div>
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 90; q1Filter.scoreMax = 100">90–100%</div>
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 70; q1Filter.scoreMax = 89">70–89%</div>
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 50; q1Filter.scoreMax = 69">50–69%</div>
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 0; q1Filter.scoreMax = 49">Below 50%</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'assign'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="c1-fp-lbl" style="margin-bottom:8px;">Filter by user</div>
            <div class="c1-agent-grid">
              <div
                v-for="user in q1UserList"
                :key="user.id"
                class="c1-agent-chip"
                :class="{ on: q1Filter.userId === user.id }"
                @click="q1Filter.userId = q1Filter.userId === user.id ? null : user.id"
              >
                <div class="c1-agent-av">{{ q1AgentInitials(user) }}</div>
                <span class="c1-agent-nm">{{ user.first_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'date'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;">
            <div class="c1-fp-lbl" style="margin-bottom:6px;">Due date</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'all' }" @click="q1Filter.due = 'all'">All</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'overdue' }" @click="q1Filter.due = 'overdue'">Overdue</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'today' }" @click="q1Filter.due = 'today'">Due today</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'this_week' }" @click="q1Filter.due = 'this_week'">This week</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'this_month' }" @click="q1Filter.due = 'this_month'">This month</div>
            </div>
            <div class="c1-fp-lbl" style="margin-top:10px;margin-bottom:6px;">Custom range</div>
            <div class="c1-date-range-row">
              <input type="date" class="c1-date-input" v-model="q1Filter.createdFrom" />
              <span class="c1-date-sep">→</span>
              <input type="date" class="c1-date-input" v-model="q1Filter.createdTo" />
            </div>
          </div>
        </div>
      </transition>
      <transition name="c1-ts-drop">
        <div v-if="c1TopTab === 'charts'" class="c1-ts-dropdown" @click.stop>
          <div style="padding:10px 14px;max-height:400px;overflow-y:auto;">
            <div class="c1-kpi-row">
              <div class="c1-kpi"><div class="c1-kpi-lbl">Pass rate</div><div class="c1-kpi-val" style="color:#22c55e">{{ q1Stats.passRate }}%</div></div>
              <div class="c1-kpi"><div class="c1-kpi-lbl">Completed</div><div class="c1-kpi-val" style="color:#6366f1">{{ q1Stats.completed }}</div></div>
              <div class="c1-kpi"><div class="c1-kpi-lbl">Pending</div><div class="c1-kpi-val" style="color:#f59e0b">{{ q1Stats.pending }}</div></div>
              <div class="c1-kpi"><div class="c1-kpi-lbl">Avg score</div><div class="c1-kpi-val">{{ q1Stats.avgScore }}%</div></div>
            </div>
            <div class="c1-fp-group c1-fp-full" style="margin-top:12px">
              <div class="c1-fp-lbl">Score distribution</div>
              <div class="q1-hist">
                <div v-for="bar in q1ScoreBars" :key="bar.label" class="q1-hist-col">
                  <div class="q1-hist-bar-wrap"><div class="q1-hist-bar" :style="{ height: bar.pct + '%', background: bar.color }"></div></div>
                  <div class="q1-hist-lbl">{{ bar.label }}</div>
                </div>
              </div>
            </div>
            <div class="c1-fp-group c1-fp-full" style="margin-top:12px">
              <div class="c1-fp-lbl">Pass rate by quiz</div>
              <div class="c1-vbar-chart">
                <div v-for="bar in q1QuizPassBars" :key="bar.label" class="c1-vbar-row">
                  <div class="c1-vbar-lbl q1-vbar-lbl-wide" :title="bar.label">{{ bar.short }}</div>
                  <div class="c1-vbar-track"><div class="c1-vbar-fill" :style="{ width: bar.pct + '%', background: bar.color }"><span class="c1-vbar-val">{{ bar.pct }}%</span></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="c1-nm-div"></div>
      <c1-mod-calendar :items="q1Quizzes" dateField="created_at" itemLabel="quizzes" style="flex-shrink:0" />
    </div>

    <!-- BACKDROP -->
    <transition name="c1-bd-fade">
      <div v-if="q1SlideOpen" class="c1-panel-backdrop" @click.stop="q1SlideOpen = null"></div>
    </transition>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- UNIFIED PANEL -->
    <div class="c1-panel" :class="{ 'c1-panel--open': q1PanelIsOpen }" @click.capture="q1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': q1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">

          <!-- User strip -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="{ on: q1UserOnline }"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <button class="c1-nav-online-btn" :class="{ on: q1UserOnline }" @click.stop="q1UserOnline = !q1UserOnline" title="Toggle online">
              <span class="c1-nav-online-knob"></span>
            </button>
            <button class="c1-nav-logout-btn" @click.stop="c1Logout()" title="Log out">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            </button>
          </div>

          <!-- Timezone bar -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="q1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="q1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- Panels mode -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">
            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;flex-shrink:0"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              Filters<span v-if="q1ActiveFilterCount" class="c1-psel-opt-badge">{{ q1ActiveFilterCount }}</span>
            </div>
            <div class="c1-psel-sub" :class="{ on: q1PanelActiveContent === 'filters' }" @click.stop="q1SelectPanel('filters')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Status · Assign · Score · Date</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr" style="margin-top:4px">
              <svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;flex-shrink:0"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              Charts
            </div>
            <div class="c1-psel-sub" :class="{ on: q1PanelActiveContent === 'charts' }" @click.stop="q1SelectPanel('charts')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Score distribution · Activity</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr" style="margin-top:4px">
              <svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;flex-shrink:0"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Calendar
            </div>
            <div class="c1-psel-sub" :class="{ on: q1PanelActiveContent === 'calendar' }" @click.stop="q1SelectPanel('calendar')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Quiz schedule</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-grp-hdr" style="margin-top:4px">
              <svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;flex-shrink:0"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              Viki<span v-if="q1VikiUnread" class="c1-psel-opt-badge">{{ q1VikiUnread }}</span>
            </div>
            <div class="c1-psel-sub" :class="{ on: q1PanelActiveContent === 'viki' }" @click.stop="q1SelectPanel('viki')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">AI Assistant</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div><!-- end v-else panels -->
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="q1SlideOpen = 'nav'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ q1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="q1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">

            <!-- FILTERS CONTENT -->
            <template v-if="q1PanelActiveContent === 'filters'">

      <!-- Filter tab menu -->
      <div class="c1-ftab-menu">
        <div class="c1-ftab-mi" :class="{ on: q1FilterTab === 'status' }" @click.stop="q1FilterTab = 'status'">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          <span>Status</span>
        </div>
        <div class="c1-ftab-mi" :class="{ on: q1FilterTab === 'assign' }" @click.stop="q1FilterTab = 'assign'">
          <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          <span>Users</span>
        </div>
        <div class="c1-ftab-mi" :class="{ on: q1FilterTab === 'score' }" @click.stop="q1FilterTab = 'score'">
          <svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
          <span>Score</span>
        </div>
        <div class="c1-ftab-mi" :class="{ on: q1FilterTab === 'date' }" @click.stop="q1FilterTab = 'date'">
          <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          <span>Date</span>
        </div>
      </div>

      <!-- Reset bar -->
      <div v-if="q1ActiveFilterCount" class="c1-reset-bar" @click.stop="q1ResetFilters()">
        <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
        Reset all filters
        <span class="c1-reset-bar-count">{{ q1ActiveFilterCount }}</span>
      </div>

      <div class="c1-sl-body">

        <!-- STATUS TAB -->
        <template v-if="q1FilterTab === 'status'">
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Quiz status</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: !q1Filter.status }" @click="q1Filter.status = null">All</div>
              <div class="c1-fp-opt q1-status-active" :class="{ on: q1Filter.status === 'active' }" @click="q1Filter.status = 'active'">Active</div>
              <div class="c1-fp-opt q1-status-draft" :class="{ on: q1Filter.status === 'draft' }" @click="q1Filter.status = 'draft'">Draft</div>
              <div class="c1-fp-opt q1-status-archived" :class="{ on: q1Filter.status === 'archived' }" @click="q1Filter.status = 'archived'">Archived</div>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="margin-top:10px">
            <div class="c1-fp-lbl">My result</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: !q1Filter.result }" @click="q1Filter.result = null">All</div>
              <div class="c1-fp-opt q1-status-passed" :class="{ on: q1Filter.result === 'passed' }" @click="q1Filter.result = 'passed'">Passed</div>
              <div class="c1-fp-opt q1-status-failed" :class="{ on: q1Filter.result === 'failed' }" @click="q1Filter.result = 'failed'">Failed</div>
              <div class="c1-fp-opt q1-status-pending" :class="{ on: q1Filter.result === 'pending' }" @click="q1Filter.result = 'pending'">Pending</div>
              <div class="c1-fp-opt q1-status-not-taken" :class="{ on: q1Filter.result === 'not_taken' }" @click="q1Filter.result = 'not_taken'">Not taken</div>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="margin-top:10px">
            <div class="c1-fp-lbl">Category</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: !q1Filter.category }" @click="q1Filter.category = null">All</div>
              <div v-for="cat in q1Categories" :key="cat" class="c1-fp-opt" :class="{ on: q1Filter.category === cat }" @click="q1Filter.category = cat">{{ cat }}</div>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="margin-top:10px">
            <div class="c1-fp-lbl">Assigned to</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: !q1Filter.assigned }" @click="q1Filter.assigned = null">All</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.assigned === 'me' }" @click="q1Filter.assigned = 'me'">Me</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.assigned === 'team' }" @click="q1Filter.assigned = 'team'">My team</div>
            </div>
          </div>
        </template>

        <!-- ASSIGN TAB -->
        <template v-if="q1FilterTab === 'assign'">
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Filter by user</div>
            <div class="c1-agent-grid">
              <div
                v-for="user in q1UserList"
                :key="user.id"
                class="c1-agent-chip"
                :class="{ on: q1Filter.userId === user.id }"
                @click="q1Filter.userId = q1Filter.userId === user.id ? null : user.id"
              >
                <div class="c1-agent-av">{{ q1AgentInitials(user) }}</div>
                <span class="c1-agent-nm">{{ user.first_name }}</span>
              </div>
            </div>
          </div>
        </template>

        <!-- SCORE TAB -->
        <template v-if="q1FilterTab === 'score'">
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Score range</div>
            <div class="q1-score-range">
              <div class="q1-sr-row">
                <span class="q1-sr-lbl">Min</span>
                <input type="range" min="0" max="100" step="5" v-model.number="q1Filter.scoreMin" class="q1-range-input" />
                <span class="q1-sr-val">{{ q1Filter.scoreMin }}%</span>
              </div>
              <div class="q1-sr-row">
                <span class="q1-sr-lbl">Max</span>
                <input type="range" min="0" max="100" step="5" v-model.number="q1Filter.scoreMax" class="q1-range-input" />
                <span class="q1-sr-val">{{ q1Filter.scoreMax }}%</span>
              </div>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="margin-top:10px">
            <div class="c1-fp-lbl">Quick ranges</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 0; q1Filter.scoreMax = 100">All</div>
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 90; q1Filter.scoreMax = 100">90–100%</div>
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 70; q1Filter.scoreMax = 89">70–89%</div>
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 50; q1Filter.scoreMax = 69">50–69%</div>
              <div class="c1-fp-opt" @click="q1Filter.scoreMin = 0; q1Filter.scoreMax = 49">Below 50%</div>
            </div>
          </div>
        </template>

        <!-- DATE TAB -->
        <template v-if="q1FilterTab === 'date'">
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Due date</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'all' }" @click="q1Filter.due = 'all'">All</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'overdue' }" @click="q1Filter.due = 'overdue'">Overdue</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'today' }" @click="q1Filter.due = 'today'">Due today</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'this_week' }" @click="q1Filter.due = 'this_week'">This week</div>
              <div class="c1-fp-opt" :class="{ on: q1Filter.due === 'this_month' }" @click="q1Filter.due = 'this_month'">This month</div>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="margin-top:10px">
            <div class="c1-fp-lbl">Date created (custom range)</div>
            <div class="c1-date-range-row">
              <input type="date" class="c1-date-input" v-model="q1Filter.createdFrom" />
              <span class="c1-date-sep">→</span>
              <input type="date" class="c1-date-input" v-model="q1Filter.createdTo" />
            </div>
          </div>
        </template>

            </template>

            <!-- CHARTS CONTENT -->
            <template v-if="q1PanelActiveContent === 'charts'">

        <!-- KPI row -->
        <div class="c1-fp-group c1-fp-full">
          <div class="c1-kpi-row">
            <div class="c1-kpi">
              <div class="c1-kpi-lbl">Pass rate</div>
              <div class="c1-kpi-val" style="color:#22c55e">{{ q1Stats.passRate }}%</div>
            </div>
            <div class="c1-kpi">
              <div class="c1-kpi-lbl">Completed</div>
              <div class="c1-kpi-val" style="color:#6366f1">{{ q1Stats.completed }}</div>
            </div>
            <div class="c1-kpi">
              <div class="c1-kpi-lbl">Pending</div>
              <div class="c1-kpi-val" style="color:#f59e0b">{{ q1Stats.pending }}</div>
            </div>
            <div class="c1-kpi">
              <div class="c1-kpi-lbl">Avg score</div>
              <div class="c1-kpi-val">{{ q1Stats.avgScore }}%</div>
            </div>
          </div>
        </div>

        <!-- Pass / Fail donut -->
        <div class="c1-fp-group c1-fp-full" style="margin-top:12px">
          <div class="c1-fp-lbl">Pass / Fail split</div>
          <div class="q1-donut-row">
            <div class="q1-donut-inner">
              <svg viewBox="0 0 36 36" class="q1-donut">
                <circle cx="18" cy="18" r="14" fill="none" stroke="#1e1e2e" stroke-width="4"/>
                <circle cx="18" cy="18" r="14" fill="none" stroke="#22c55e" stroke-width="4"
                  :stroke-dasharray="q1DonArc(q1Stats.passed, q1Stats.completed) + ' ' + (88 - q1DonArc(q1Stats.passed, q1Stats.completed))"
                  stroke-dashoffset="0" stroke-linecap="round"/>
                <circle cx="18" cy="18" r="14" fill="none" stroke="#ef4444" stroke-width="4"
                  :stroke-dasharray="q1DonArc(q1Stats.failed, q1Stats.completed) + ' ' + (88 - q1DonArc(q1Stats.failed, q1Stats.completed))"
                  :stroke-dashoffset="'-' + q1DonArc(q1Stats.passed, q1Stats.completed)"
                  stroke-linecap="round"/>
              </svg>
              <div class="q1-donut-center">{{ q1Stats.passRate }}%</div>
            </div>
            <div class="q1-donut-leg">
              <div class="q1-dl-item"><span class="q1-dl-dot" style="background:#22c55e"></span>Passed <strong>{{ q1Stats.passed }}</strong></div>
              <div class="q1-dl-item"><span class="q1-dl-dot" style="background:#ef4444"></span>Failed <strong>{{ q1Stats.failed }}</strong></div>
              <div class="q1-dl-item"><span class="q1-dl-dot" style="background:#f59e0b"></span>Pending <strong>{{ q1Stats.pending }}</strong></div>
            </div>
          </div>
        </div>

        <!-- Score distribution histogram -->
        <div class="c1-fp-group c1-fp-full" style="margin-top:12px">
          <div class="c1-fp-lbl">Score distribution</div>
          <div class="q1-hist">
            <div v-for="bar in q1ScoreBars" :key="bar.label" class="q1-hist-col">
              <div class="q1-hist-bar-wrap">
                <div class="q1-hist-bar" :style="{ height: bar.pct + '%', background: bar.color }"></div>
              </div>
              <div class="q1-hist-lbl">{{ bar.label }}</div>
            </div>
          </div>
        </div>

        <!-- Pass rate by quiz -->
        <div class="c1-fp-group c1-fp-full" style="margin-top:12px">
          <div class="c1-fp-lbl">Pass rate by quiz</div>
          <div class="c1-vbar-chart">
            <div v-for="bar in q1QuizPassBars" :key="bar.label" class="c1-vbar-row">
              <div class="c1-vbar-lbl q1-vbar-lbl-wide" :title="bar.label">{{ bar.short }}</div>
              <div class="c1-vbar-track">
                <div class="c1-vbar-fill" :style="{ width: bar.pct + '%', background: bar.color }">
                  <span class="c1-vbar-val">{{ bar.pct }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Completion trend -->
        <div class="c1-fp-group c1-fp-full" style="margin-top:12px">
          <div class="c1-fp-lbl">Completion trend (last 6 weeks)</div>
          <div class="c1-vbar-chart">
            <div v-for="bar in q1TrendBars" :key="bar.label" class="c1-vbar-row">
              <div class="c1-vbar-lbl">{{ bar.label }}</div>
              <div class="c1-vbar-track">
                <div class="c1-vbar-fill q1-vbar-ac" :style="{ width: bar.pct + '%' }">
                  <span class="c1-vbar-val">{{ bar.val }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Avg time to complete -->
        <div class="c1-fp-group c1-fp-full" style="margin-top:12px">
          <div class="c1-fp-lbl">Avg time to complete (min)</div>
          <div class="c1-vbar-chart">
            <div v-for="bar in q1TimeBars" :key="bar.label" class="c1-vbar-row">
              <div class="c1-vbar-lbl q1-vbar-lbl-wide" :title="bar.label">{{ bar.short }}</div>
              <div class="c1-vbar-track">
                <div class="c1-vbar-fill" :style="{ width: bar.pct + '%', background: '#8b5cf6' }">
                  <span class="c1-vbar-val">{{ bar.val }}m</span>
                </div>
              </div>
            </div>
          </div>
        </div>

            </template>

            <!-- CALENDAR CONTENT -->
            <template v-if="q1PanelActiveContent === 'calendar'">
        <div class="q1-cal-hdr">
          <button class="q1-cal-nav" @click="q1CalPrev">&#8249;</button>
          <span class="q1-cal-title">{{ q1CalMonthNames[q1Cal.month] }} {{ q1Cal.year }}</span>
          <button class="q1-cal-nav" @click="q1CalNext">&#8250;</button>
        </div>
        <div class="q1-cal-grid">
          <div class="q1-cal-dow" v-for="(d, di) in ['M','T','W','T','F','S','S']" :key="'dow-' + di">{{ d }}</div>
          <div
            v-for="cell in q1CalGrid"
            :key="cell.date"
            class="q1-cal-cell"
            :class="{
              'q1-cal-out': !cell.inMonth,
              'q1-cal-today': cell.today,
              'q1-cal-has-exam': cell.hasExam,
              'q1-cal-due': cell.isDue
            }"
          >
            <span>{{ cell.day }}</span>
            <span v-if="cell.hasExam || cell.isDue" class="q1-cal-dot" :style="{ background: cell.hasExam ? '#6366f1' : '#f59e0b' }"></span>
          </div>
        </div>
        <div class="q1-cal-legend">
          <span class="q1-cl-item"><span class="q1-cl-dot" style="background:#6366f1"></span>Exam taken</span>
          <span class="q1-cl-item"><span class="q1-cl-dot" style="background:#f59e0b"></span>Due date</span>
        </div>
        <!-- Upcoming due exams -->
        <div style="margin-top:14px">
          <div class="c1-fp-lbl">Upcoming deadlines</div>
          <div v-if="q1UpcomingDue.length === 0" class="q1-cal-empty">No upcoming deadlines</div>
          <div v-for="exam in q1UpcomingDue" :key="exam.id" class="q1-cal-upcoming-row">
            <div class="q1-due-dot" :class="{ overdue: q1IsOverdue(exam.dueDate) }"></div>
            <div class="q1-cal-upcoming-info">
              <div class="q1-cal-upcoming-title">{{ exam.title }}</div>
              <div class="q1-cal-upcoming-due" :class="{ overdue: q1IsOverdue(exam.dueDate) }">{{ q1FmtDue(exam.dueDate) }}</div>
            </div>
            <span class="q1-status-chip" :class="'q1-s-' + exam.myStatus">{{ q1StatusLabel(exam.myStatus) }}</span>
          </div>
        </div>
            </template>

            <!-- VIKI CONTENT -->
            <template v-if="q1PanelActiveContent === 'viki'">
        <div v-if="q1VikiMessages.length === 0" class="q1-viki-empty">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
          No messages from Viki
        </div>
        <div v-for="msg in q1VikiMessages" :key="msg.id" class="q1-viki-msg" :class="{ unread: !msg.read, [msg.type]: true }" @click="q1MarkVikiRead(msg.id)">
          <div class="q1-viki-msg-icon">
            <svg v-if="msg.type === 'success'" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
            <svg v-else-if="msg.type === 'warning'" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            <svg v-else viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </div>
          <div class="q1-viki-msg-body">
            <div class="q1-viki-msg-text">{{ msg.text }}</div>
            <div class="q1-viki-msg-time">{{ q1FmtTime(msg.ts) }}</div>
          </div>
          <div v-if="!msg.read" class="q1-viki-unread-dot"></div>
        </div>
        <div v-if="q1VikiUnread" class="q1-viki-mark-all" @click="q1MarkAllVikiRead">
          Mark all as read
        </div>
            </template>

          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- VIEW TOGGLE TABS                                   -->
    <!-- ══════════════════════════════════════════════════ -->
    <div class="q1-view-tabs">
      <div class="q1-vt" :class="{ on: q1View === 'my' }" @click="q1View = 'my'">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
        My Quizzes
      </div>
      <div v-if="q1IsManager" class="q1-vt" :class="{ on: q1View === 'all' }" @click="q1SwitchToAll">
        <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        All Agents
      </div>
      <div v-if="q1IsManager" class="q1-vt" :class="{ on: q1View === 'scoreboard' }" @click="q1SwitchToScoreboard">
        <svg viewBox="0 0 24 24"><polyline points="17 11 21 7 17 3"/><line x1="21" y1="7" x2="9" y2="7"/><polyline points="7 21 3 17 7 13"/><line x1="15" y1="17" x2="3" y2="17"/></svg>
        Scoreboard
      </div>
      <div v-if="q1IsManager" class="q1-vt" :class="{ on: q1View === 'settings' }" @click="q1View = 'settings'; q1DrawerOpen = false; q1SlideOpen = null">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
        Settings
      </div>
      <div class="c1-hp"></div>
      <!-- Search bar -->
      <div class="q1-search-wrap">
        <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input v-model.trim="q1SearchText" class="q1-search-input" placeholder="Search quizzes…" type="text" />
        <div v-if="q1SearchText" class="q1-search-clear" @click="q1SearchText = ''">
          <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </div>
      </div>
      <div v-if="q1IsManager" class="q1-add-btn" @click="q1OpenCreate">
        <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        New Quiz
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- LOADING STATE                                      -->
    <!-- ══════════════════════════════════════════════════ -->
    <div v-if="q1Loading" class="q1-loading">
      <div class="c1-spinner"></div>
      <div class="q1-loading-txt">Loading quizzes…</div>
    </div>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- MY QUIZZES VIEW                                    -->
    <!-- ══════════════════════════════════════════════════ -->
    <div v-else-if="q1View === 'my'" class="q1-list">

      <!-- Summary strip -->
      <div class="q1-my-summary">
        <div class="q1-my-kpi" v-for="k in q1MyKpis" :key="k.label">
          <div class="q1-my-kpi-val" :style="{ color: k.color }">{{ k.val }}</div>
          <div class="q1-my-kpi-lbl">{{ k.label }}</div>
        </div>
      </div>

      <div v-if="q1FilteredQuizzes.length === 0" class="q1-empty">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        <div class="q1-empty-msg">No quizzes match your filters</div>
        <button class="q1-btn q1-btn-ghost" style="margin-top:8px" @click="q1ResetFilters">Clear filters</button>
      </div>

      <div v-for="quiz in q1FilteredQuizzes" :key="quiz.id" class="q1-exam-row" :class="{ expanded: q1ExpandedExam === quiz.id }">
        <!-- Row header -->
        <div class="q1-exam-hdr" @click="q1ToggleExam(quiz.id)">
          <div class="q1-exam-acc" :style="{ background: q1StatusColor(quiz.myStatus) }"></div>
          <div class="q1-exam-info">
            <div class="q1-exam-title">{{ quiz.title }}</div>
            <div class="q1-exam-meta">
              <span class="q1-cat-chip">{{ quiz.category }}</span>
              <span class="q1-meta-sep">·</span>
              <span class="q1-meta-item">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/></svg>
                {{ quiz.questionCount }} q
              </span>
              <span v-if="quiz.timeLimit" class="q1-meta-sep">·</span>
              <span v-if="quiz.timeLimit" class="q1-meta-item">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                {{ quiz.timeLimit }}m
              </span>
              <span class="q1-meta-sep">·</span>
              <span class="q1-status-chip" :class="'q1-s-' + quiz.myStatus">
                {{ q1StatusLabel(quiz.myStatus) }}
                <svg v-if="quiz.myStatus === 'passed'" viewBox="0 0 24 24" class="q1-s-ico"><polyline points="20 6 9 17 4 12"/></svg>
                <svg v-else-if="quiz.myStatus === 'failed'" viewBox="0 0 24 24" class="q1-s-ico"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </span>
            </div>
          </div>
          <div class="q1-exam-right">
            <div v-if="quiz.myScore !== null" class="q1-score-pill" :class="quiz.myScore >= quiz.passThreshold ? 'pass' : 'fail'">
              {{ quiz.myScore }}%
            </div>
            <div class="q1-due-lbl" :class="{ overdue: q1IsOverdue(quiz.dueDate) }">
              {{ q1FmtDue(quiz.dueDate) }}
            </div>
            <svg class="q1-chv" :class="{ open: q1ExpandedExam === quiz.id }" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>

        <!-- Expanded detail -->
        <transition name="q1-expand">
          <div v-if="q1ExpandedExam === quiz.id" class="q1-exam-body">
            <div class="q1-exam-detail-grid">
              <div class="q1-ed-field q1-ed-full">
                <div class="q1-ed-lbl">Description</div>
                <div class="q1-ed-val">{{ quiz.description || '—' }}</div>
              </div>
              <div class="q1-ed-field">
                <div class="q1-ed-lbl">Questions</div>
                <div class="q1-ed-val">{{ quiz.questionCount }}</div>
              </div>
              <div class="q1-ed-field">
                <div class="q1-ed-lbl">Time limit</div>
                <div class="q1-ed-val">{{ quiz.timeLimit ? quiz.timeLimit + ' min' : 'No limit' }}</div>
              </div>
              <div class="q1-ed-field">
                <div class="q1-ed-lbl">Pass threshold</div>
                <div class="q1-ed-val">{{ quiz.passThreshold }}%</div>
              </div>
              <div class="q1-ed-field">
                <div class="q1-ed-lbl">Attempts left</div>
                <div class="q1-ed-val">{{ quiz.attemptsRemaining !== null ? quiz.attemptsRemaining : '∞' }}</div>
              </div>
              <div v-if="quiz.myScore !== null" class="q1-ed-field">
                <div class="q1-ed-lbl">Best score</div>
                <div class="q1-ed-val" :style="{ color: quiz.myScore >= quiz.passThreshold ? '#22c55e' : '#ef4444', fontWeight: 700 }">{{ quiz.myScore }}%</div>
              </div>
              <div v-if="quiz.dateTaken" class="q1-ed-field">
                <div class="q1-ed-lbl">Last taken</div>
                <div class="q1-ed-val q1-mono">{{ q1FmtDate(quiz.dateTaken) }}</div>
              </div>
              <div v-if="quiz.avgScore" class="q1-ed-field">
                <div class="q1-ed-lbl">Team avg score</div>
                <div class="q1-ed-val">{{ quiz.avgScore }}%</div>
              </div>
              <div class="q1-ed-field">
                <div class="q1-ed-lbl">Created</div>
                <div class="q1-ed-val q1-mono">{{ q1FmtDate(quiz.createdAt) }}</div>
              </div>
              <div v-if="quiz.assignedTo" class="q1-ed-field">
                <div class="q1-ed-lbl">Assigned to</div>
                <div class="q1-ed-val">{{ quiz.assignedTo }}</div>
              </div>
            </div>

            <!-- Attempts history mini-list -->
            <div v-if="quiz.attempts && quiz.attempts.length" class="q1-attempts-section">
              <div class="q1-attempts-lbl">Attempt history</div>
              <div class="q1-attempts-list">
                <div v-for="(att, ai) in quiz.attempts" :key="ai" class="q1-attempt-row">
                  <span class="q1-att-num">#{{ ai + 1 }}</span>
                  <span class="q1-att-score" :class="att.score >= quiz.passThreshold ? 'pass' : 'fail'">{{ att.score }}%</span>
                  <span class="q1-att-time">{{ q1FmtTimer(att.timeTaken) }}</span>
                  <span class="q1-att-date q1-mono">{{ q1FmtDate(att.date) }}</span>
                  <span class="q1-status-chip q1-s-sm" :class="att.score >= quiz.passThreshold ? 'q1-s-passed' : 'q1-s-failed'">
                    {{ att.score >= quiz.passThreshold ? 'Passed' : 'Failed' }}
                  </span>
                </div>
              </div>
            </div>

            <div class="q1-exam-actions">
              <button
                v-if="quiz.myStatus !== 'passed' && (quiz.attemptsRemaining === null || quiz.attemptsRemaining > 0)"
                class="q1-btn q1-btn-take"
                @click.stop="q1StartQuiz(quiz)"
              >
                <svg viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                {{ quiz.myStatus === 'not_taken' ? 'Start quiz' : 'Retake quiz' }}
              </button>
              <button
                v-if="quiz.myStatus === 'passed' || quiz.myStatus === 'failed'"
                class="q1-btn q1-btn-review"
                @click.stop="q1OpenResults(quiz)"
              >
                <svg viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                Review results
              </button>
              <button
                v-if="q1IsManager"
                class="q1-btn q1-btn-ghost"
                @click.stop="q1OpenEdit(quiz)"
              >
                <svg viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                Edit
              </button>
              <button
                v-if="q1IsManager"
                class="q1-btn q1-btn-ghost q1-btn-danger"
                @click.stop="q1ArchiveQuiz(quiz)"
              >
                <svg viewBox="0 0 24 24"><polyline points="21 8 21 21 3 21 3 8"/><rect x="1" y="3" width="22" height="5"/><line x1="10" y1="12" x2="14" y2="12"/></svg>
                Archive
              </button>
              <div class="c1-hp"></div>
              <button class="q1-btn q1-btn-export" @click.stop="q1ExportQuizCSV(quiz)">
                <svg viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                Export
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- ALL AGENTS VIEW (manager)                          -->
    <!-- ══════════════════════════════════════════════════ -->
    <div v-else-if="q1View === 'all' && q1IsManager" class="q1-list">
      <div v-if="q1AllUsersLoading" class="q1-loading">
        <div class="c1-spinner"></div>
        <div class="q1-loading-txt">Loading agent data…</div>
      </div>
      <template v-else>
        <!-- Quiz selector for per-quiz drill down -->
        <div class="q1-quiz-selector">
          <div class="q1-qs-lbl">Filter by quiz:</div>
          <div class="q1-qs-chips">
            <div class="q1-qs-chip" :class="{ on: !q1SelectedQuizId }" @click="q1SelectedQuizId = null">All quizzes</div>
            <div
              v-for="quiz in q1Quizzes"
              :key="quiz.id"
              class="q1-qs-chip"
              :class="{ on: q1SelectedQuizId === quiz.id }"
              @click="q1SelectedQuizId = quiz.id"
            >{{ quiz.title }}</div>
          </div>
        </div>

        <!-- Team summary header -->
        <div class="q1-team-summary">
          <div class="q1-ts-kpi" v-for="k in q1TeamKpis" :key="k.label">
            <div class="q1-ts-val" :style="{ color: k.color }">{{ k.val }}</div>
            <div class="q1-ts-lbl">{{ k.label }}</div>
          </div>
        </div>

        <!-- Per-user rows -->
        <div v-for="userRow in q1FilteredUserRows" :key="userRow.userId" class="q1-user-block">
          <div class="q1-user-block-hdr" @click="q1ToggleUser(userRow.userId)">
            <div class="q1-ub-av">{{ q1AgentInitials(userRow) }}</div>
            <div class="q1-ub-info">
              <div class="q1-ub-name">{{ userRow.first_name }} {{ userRow.last_name }}</div>
              <div class="q1-ub-meta">
                <span class="q1-ub-pass">{{ userRow.passed }} passed</span>
                <span class="q1-ub-sep">·</span>
                <span class="q1-ub-pending">{{ userRow.pending }} pending</span>
                <span class="q1-ub-sep">·</span>
                <span class="q1-ub-rate">{{ userRow.passRate }}% rate</span>
                <span v-if="userRow.avgTime" class="q1-ub-sep">·</span>
                <span v-if="userRow.avgTime" class="q1-ub-time">avg {{ q1FmtTimer(userRow.avgTime) }}</span>
              </div>
            </div>
            <div class="q1-ub-prog-wrap">
              <div class="q1-ub-prog-track">
                <div class="q1-ub-prog-fill" :style="{ width: userRow.passRate + '%' }"></div>
              </div>
              <div class="q1-ub-prog-lbl">{{ userRow.passRate }}%</div>
            </div>
            <svg class="q1-chv" :class="{ open: q1ExpandedUser === userRow.userId }" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>
          </div>

          <!-- Per-user quiz detail -->
          <transition name="q1-expand">
            <div v-if="q1ExpandedUser === userRow.userId" class="q1-ub-exams">
              <div v-for="exam in userRow.exams" :key="exam.id" class="q1-ub-exam-row">
                <span class="q1-cat-chip q1-cat-chip-sm">{{ exam.category }}</span>
                <span class="q1-ub-exam-title">{{ exam.title }}</span>
                <div class="c1-hp"></div>
                <span v-if="exam.timeTaken" class="q1-ub-time-pill">{{ q1FmtTimer(exam.timeTaken) }}</span>
                <span class="q1-status-chip q1-s-sm" :class="'q1-s-' + exam.status">{{ q1StatusLabel(exam.status) }}</span>
                <span v-if="exam.score !== null" class="q1-score-pill q1-score-pill-sm" :class="exam.score >= exam.passThreshold ? 'pass' : 'fail'">{{ exam.score }}%</span>
                <button v-if="exam.score !== null" class="q1-ub-review-btn" @click.stop="q1ManagerViewResult(userRow, exam)">
                  <svg viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                </button>
              </div>
            </div>
          </transition>
        </div>

        <div v-if="q1FilteredUserRows.length === 0" class="q1-empty">
          <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
          <div class="q1-empty-msg">No agent data available</div>
        </div>

        <!-- Export button -->
        <div class="q1-export-bar">
          <button class="q1-btn q1-btn-export q1-btn-full" @click="q1ExportTeamCSV">
            <svg viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Export all results to CSV
          </button>
        </div>
      </template>
    </div>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- SCOREBOARD VIEW (manager)                          -->
    <!-- ══════════════════════════════════════════════════ -->
    <div v-else-if="q1View === 'scoreboard' && q1IsManager" class="q1-list">
      <div v-if="q1AllUsersLoading" class="q1-loading">
        <div class="c1-spinner"></div>
      </div>
      <template v-else>
        <!-- Quiz selector -->
        <div class="q1-quiz-selector">
          <div class="q1-qs-lbl">Select quiz:</div>
          <div class="q1-qs-chips">
            <div class="q1-qs-chip" :class="{ on: !q1ScoreboardQuizId }" @click="q1ScoreboardQuizId = null">All</div>
            <div
              v-for="quiz in q1Quizzes"
              :key="quiz.id"
              class="q1-qs-chip"
              :class="{ on: q1ScoreboardQuizId === quiz.id }"
              @click="q1ScoreboardQuizId = quiz.id"
            >{{ quiz.title }}</div>
          </div>
        </div>

        <!-- Scoreboard table -->
        <div class="q1-scoreboard">
          <div class="q1-sb-hdr">
            <div class="q1-sb-rank">#</div>
            <div class="q1-sb-name">Agent</div>
            <div class="q1-sb-score">Best score</div>
            <div class="q1-sb-time">Avg time</div>
            <div class="q1-sb-attempts">Attempts</div>
            <div class="q1-sb-status">Status</div>
          </div>
          <div
            v-for="(row, ri) in q1ScoreboardRows"
            :key="row.userId"
            class="q1-sb-row"
            :class="{ 'q1-sb-top': ri < 3, ['q1-sb-rank-' + (ri + 1)]: ri < 3 }"
          >
            <div class="q1-sb-rank">
              <span v-if="ri === 0" class="q1-sb-medal gold">1</span>
              <span v-else-if="ri === 1" class="q1-sb-medal silver">2</span>
              <span v-else-if="ri === 2" class="q1-sb-medal bronze">3</span>
              <span v-else class="q1-sb-rank-num">{{ ri + 1 }}</span>
            </div>
            <div class="q1-sb-name">
              <div class="q1-sb-av">{{ q1AgentInitials(row) }}</div>
              <span>{{ row.first_name }} {{ row.last_name }}</span>
            </div>
            <div class="q1-sb-score">
              <span class="q1-score-pill" :class="row.bestScore >= 70 ? 'pass' : 'fail'">{{ row.bestScore }}%</span>
            </div>
            <div class="q1-sb-time q1-mono">{{ row.avgTime ? q1FmtTimer(row.avgTime) : '—' }}</div>
            <div class="q1-sb-attempts">{{ row.attempts }}</div>
            <div class="q1-sb-status">
              <span class="q1-status-chip" :class="row.bestScore >= 70 ? 'q1-s-passed' : 'q1-s-failed'">
                {{ row.bestScore >= 70 ? 'Passed' : 'Failed' }}
              </span>
            </div>
          </div>
          <div v-if="q1ScoreboardRows.length === 0" class="q1-empty" style="padding:24px">
            No scores yet
          </div>
        </div>
      </template>
    </div>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- SETTINGS VIEW (manager)                            -->
    <!-- ══════════════════════════════════════════════════ -->
    <div v-else-if="q1View === 'settings' && q1IsManager" class="q1-list q1-settings-wrap">
      <div class="q1-set-section">
        <div class="q1-set-section-title">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
          Default Quiz Behavior
        </div>
        <div class="q1-set-grid">
          <div class="q1-set-row">
            <div class="q1-set-lbl">
              <div class="q1-set-lbl-name">Default pass threshold</div>
              <div class="q1-set-lbl-hint">Minimum score % required to pass a quiz</div>
            </div>
            <div class="q1-set-ctrl">
              <div class="q1-set-num-wrap">
                <input type="number" class="q1-set-num" v-model.number="q1Settings.defaultPassThreshold" min="1" max="100" />
                <span class="q1-set-unit">%</span>
              </div>
            </div>
          </div>
          <div class="q1-set-row">
            <div class="q1-set-lbl">
              <div class="q1-set-lbl-name">Default time limit</div>
              <div class="q1-set-lbl-hint">Minutes per quiz attempt (0 = no limit)</div>
            </div>
            <div class="q1-set-ctrl">
              <div class="q1-set-num-wrap">
                <input type="number" class="q1-set-num" v-model.number="q1Settings.defaultTimeLimit" min="0" max="300" />
                <span class="q1-set-unit">min</span>
              </div>
            </div>
          </div>
          <div class="q1-set-row">
            <div class="q1-set-lbl">
              <div class="q1-set-lbl-name">Max attempts per agent</div>
              <div class="q1-set-lbl-hint">0 = unlimited retakes</div>
            </div>
            <div class="q1-set-ctrl">
              <div class="q1-set-num-wrap">
                <input type="number" class="q1-set-num" v-model.number="q1Settings.defaultMaxAttempts" min="0" max="99" />
                <span class="q1-set-unit">×</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="q1-set-section">
        <div class="q1-set-section-title">
          <svg viewBox="0 0 24 24"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>
          Notifications
        </div>
        <div class="q1-set-grid">
          <div class="q1-set-row">
            <div class="q1-set-lbl">
              <div class="q1-set-lbl-name">Notify manager on agent fail</div>
              <div class="q1-set-lbl-hint">Send an alert when an agent fails a quiz</div>
            </div>
            <div class="q1-set-ctrl">
              <div class="q1-set-toggle" :class="{ on: q1Settings.notifyOnFail }" @click="q1Settings.notifyOnFail = !q1Settings.notifyOnFail">
                <div class="q1-set-toggle-knob"></div>
              </div>
            </div>
          </div>
          <div class="q1-set-row">
            <div class="q1-set-lbl">
              <div class="q1-set-lbl-name">Mandatory quizzes</div>
              <div class="q1-set-lbl-hint">Agents must complete assigned quizzes before login</div>
            </div>
            <div class="q1-set-ctrl">
              <div class="q1-set-toggle" :class="{ on: q1Settings.mandatoryQuizzes }" @click="q1Settings.mandatoryQuizzes = !q1Settings.mandatoryQuizzes">
                <div class="q1-set-toggle-knob"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="q1-set-section">
        <div class="q1-set-section-title">
          <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
          Quiz Instruction Text
        </div>
        <div class="q1-set-grid">
          <div class="q1-set-row q1-set-row-col">
            <div class="q1-set-lbl">
              <div class="q1-set-lbl-name">Default instruction shown before every quiz</div>
              <div class="q1-set-lbl-hint">Displayed to agents on the quiz start screen</div>
            </div>
            <textarea class="q1-set-textarea" v-model="q1Settings.instructionText" rows="5" placeholder="e.g. Read each question carefully. You have one attempt. Your score will be reported to your manager."></textarea>
          </div>
        </div>
      </div>

      <div class="q1-set-section">
        <div class="q1-set-section-title">
          <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
          Categories
        </div>
        <div class="q1-set-grid">
          <div class="q1-set-row q1-set-row-col">
            <div class="q1-set-lbl">
              <div class="q1-set-lbl-name">Manage quiz categories</div>
              <div class="q1-set-lbl-hint">Add or remove quiz categories used when building quizzes</div>
            </div>
            <div class="q1-cat-mgr">
              <div class="q1-cat-list">
                <div v-for="(cat, ci) in q1Settings.categories" :key="ci" class="q1-cat-item">
                  <span class="q1-cat-chip">{{ cat }}</span>
                  <button class="q1-cat-del" @click="q1Settings.categories.splice(ci, 1)">
                    <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </button>
                </div>
              </div>
              <div class="q1-cat-add-row">
                <input type="text" class="q1-set-input" v-model="q1NewCategory" placeholder="New category name..." @keydown.enter="q1AddCategory" />
                <button class="q1-btn q1-btn-sm q1-btn-purple" @click="q1AddCategory">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="q1-set-actions">
        <button class="q1-btn q1-btn-purple" :class="{ loading: q1SettingsSaving }" @click="q1SaveSettings">
          <svg v-if="!q1SettingsSaving" viewBox="0 0 24 24"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
          <div v-else class="c1-spinner" style="width:14px;height:14px;border-color:rgba(255,255,255,.4);border-top-color:#fff"></div>
          Save settings
        </button>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- QUIZ TAKING DRAWER (full screen slide)             -->
    <!-- ══════════════════════════════════════════════════ -->
    <transition name="q1-drawer">
      <div v-if="q1DrawerOpen" class="q1-drawer-wrap" @click.self="q1ConfirmCloseDrawer">
        <div class="q1-drawer">

          <!-- TAKE QUIZ MODE -->
          <template v-if="q1DrawerMode === 'take'">
            <div class="q1-dr-head">
              <div class="q1-dr-title">{{ q1ActiveQuiz ? q1ActiveQuiz.title : '' }}</div>
              <div class="q1-dr-sub">
                <span class="q1-q-counter">Question {{ q1QIdx + 1 }} of {{ q1ActiveQuestions.length }}</span>
                <span v-if="q1TimerActive" class="q1-timer" :class="{ urgent: q1TimeLeft < 60 }">
                  &nbsp;·&nbsp;
                  <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  {{ q1FmtTimer(q1TimeLeft) }}
                </span>
              </div>
              <button class="q1-dr-close" @click="q1ConfirmCloseDrawer">
                <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>

            <!-- Progress bar -->
            <div class="q1-progress-track">
              <div class="q1-progress-fill" :style="{ width: (((q1QIdx) / q1ActiveQuestions.length) * 100) + '%' }"></div>
            </div>

            <!-- Question dots nav -->
            <div class="q1-q-dots">
              <div
                v-for="(q, qi) in q1ActiveQuestions"
                :key="qi"
                class="q1-q-dot"
                :class="{
                  answered: q1UserAnswers[qi] !== null,
                  current: qi === q1QIdx,
                  skipped: q1UserAnswers[qi] === null && qi < q1QIdx
                }"
              ></div>
            </div>

            <!-- Question body -->
            <div class="q1-dr-body" v-if="q1ActiveQuestions.length > 0 && !q1ShowScore">
              <div class="q1-q-wrap">
                <div class="q1-q-number">Q{{ q1QIdx + 1 }}</div>
                <div class="q1-q-text">{{ q1ActiveQuestions[q1QIdx].text }}</div>
                <div class="q1-q-type-badge" v-if="q1ActiveQuestions[q1QIdx].type === 'true_false'">True / False</div>
              </div>

              <!-- Multiple choice answers -->
              <div class="q1-answers" v-if="q1ActiveQuestions[q1QIdx].type !== 'true_false'">
                <div
                  v-for="(ans, ai) in q1ActiveQuestions[q1QIdx].answers"
                  :key="ai"
                  class="q1-ans-opt"
                  :class="{
                    selected: q1UserAnswers[q1QIdx] === ai,
                    correct: q1AnswerRevealed && ans.correct,
                    wrong: q1AnswerRevealed && q1UserAnswers[q1QIdx] === ai && !ans.correct,
                    disabled: q1AnswerRevealed
                  }"
                  @click="q1SelectAnswer(ai)"
                >
                  <span class="q1-ans-letter">{{ String.fromCharCode(65 + ai) }}</span>
                  <span class="q1-ans-text">{{ ans.text }}</span>
                  <svg v-if="q1AnswerRevealed && ans.correct" class="q1-ans-ico correct" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                  <svg v-else-if="q1AnswerRevealed && q1UserAnswers[q1QIdx] === ai && !ans.correct" class="q1-ans-ico wrong" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </div>
              </div>

              <!-- True / False answers -->
              <div class="q1-tf-answers" v-else>
                <div
                  class="q1-tf-opt"
                  :class="{
                    selected: q1UserAnswers[q1QIdx] === 0,
                    correct: q1AnswerRevealed && q1ActiveQuestions[q1QIdx].answers[0] && q1ActiveQuestions[q1QIdx].answers[0].correct,
                    wrong: q1AnswerRevealed && q1UserAnswers[q1QIdx] === 0 && q1ActiveQuestions[q1QIdx].answers[0] && !q1ActiveQuestions[q1QIdx].answers[0].correct
                  }"
                  @click="q1SelectAnswer(0)"
                >
                  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                  True
                </div>
                <div
                  class="q1-tf-opt q1-tf-false"
                  :class="{
                    selected: q1UserAnswers[q1QIdx] === 1,
                    correct: q1AnswerRevealed && q1ActiveQuestions[q1QIdx].answers[1] && q1ActiveQuestions[q1QIdx].answers[1].correct,
                    wrong: q1AnswerRevealed && q1UserAnswers[q1QIdx] === 1 && q1ActiveQuestions[q1QIdx].answers[1] && !q1ActiveQuestions[q1QIdx].answers[1].correct
                  }"
                  @click="q1SelectAnswer(1)"
                >
                  <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  False
                </div>
              </div>

              <!-- Explanation shown after answer revealed -->
              <transition name="q1-fade">
                <div
                  v-if="q1AnswerRevealed && q1ActiveQuestions[q1QIdx].explanation"
                  class="q1-explanation"
                >
                  <div class="q1-exp-lbl">Explanation</div>
                  <div class="q1-exp-text">{{ q1ActiveQuestions[q1QIdx].explanation }}</div>
                </div>
              </transition>
            </div>

            <!-- Score / results screen -->
            <div class="q1-dr-body q1-score-screen" v-if="q1ShowScore">
              <div class="q1-score-circle" :class="q1FinalScore >= (q1ActiveQuiz ? q1ActiveQuiz.passThreshold : 70) ? 'pass' : 'fail'">
                <div class="q1-sc-pct">{{ q1FinalScore }}%</div>
                <div class="q1-sc-lbl">{{ q1FinalScore >= (q1ActiveQuiz ? q1ActiveQuiz.passThreshold : 70) ? 'PASSED' : 'FAILED' }}</div>
              </div>

              <div class="q1-score-banner" :class="q1FinalScore >= (q1ActiveQuiz ? q1ActiveQuiz.passThreshold : 70) ? 'pass' : 'fail'">
                {{ q1FinalScore >= (q1ActiveQuiz ? q1ActiveQuiz.passThreshold : 70) ? 'Congratulations! You passed.' : 'Keep studying. You can retake this quiz.' }}
              </div>

              <div class="q1-score-stats-grid">
                <div class="q1-ss-item">
                  <div class="q1-ss-val" style="color:#22c55e">{{ q1CorrectCount }}</div>
                  <div class="q1-ss-lbl">Correct</div>
                </div>
                <div class="q1-ss-item">
                  <div class="q1-ss-val" style="color:#ef4444">{{ q1ActiveQuestions.length - q1CorrectCount }}</div>
                  <div class="q1-ss-lbl">Wrong</div>
                </div>
                <div class="q1-ss-item">
                  <div class="q1-ss-val q1-mono">{{ q1FmtTimer(q1TimeTaken) }}</div>
                  <div class="q1-ss-lbl">Time</div>
                </div>
                <div class="q1-ss-item">
                  <div class="q1-ss-val">{{ q1ActiveQuiz ? q1ActiveQuiz.passThreshold : 70 }}%</div>
                  <div class="q1-ss-lbl">Pass mark</div>
                </div>
              </div>

              <!-- Wrong answers review inline -->
              <div v-if="q1WrongAnswers.length > 0" class="q1-wrong-section">
                <div class="q1-wrong-hdr">
                  <svg viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                  Review wrong answers ({{ q1WrongAnswers.length }})
                </div>
                <div v-for="(wa, wi) in q1WrongAnswers" :key="wi" class="q1-rev-q">
                  <div class="q1-rev-q-hdr">
                    <span class="q1-rev-num">Q{{ wa.qIdx + 1 }}</span>
                    <span class="q1-rev-text">{{ wa.text }}</span>
                    <svg class="q1-rev-ico wrong" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </div>
                  <div class="q1-rev-answers">
                    <div v-for="(ans, ai) in wa.answers" :key="ai" class="q1-rev-ans"
                      :class="{ correct: ans.correct, selected: wa.chosen === ai && !ans.correct }">
                      <span class="q1-ans-letter">{{ String.fromCharCode(65 + ai) }}</span>
                      {{ ans.text }}
                      <span v-if="ans.correct" class="q1-rev-correct-tag">correct</span>
                      <span v-if="wa.chosen === ai && !ans.correct" class="q1-rev-your-tag">your answer</span>
                    </div>
                  </div>
                  <div v-if="wa.explanation" class="q1-explanation q1-exp-sm">
                    <div class="q1-exp-lbl">Explanation</div>
                    <div class="q1-exp-text">{{ wa.explanation }}</div>
                  </div>
                </div>
              </div>

              <div class="q1-score-actions">
                <button class="q1-btn q1-btn-take" style="flex:1" @click="q1CloseDrawer">Done</button>
                <button class="q1-btn q1-btn-ghost" style="flex:1" @click="q1ShareResult">
                  <svg viewBox="0 0 24 24"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                  Share
                </button>
              </div>
            </div>

            <!-- Footer nav -->
            <div v-if="!q1ShowScore" class="q1-dr-foot">
              <div class="q1-foot-left">
                <span class="q1-foot-answered">{{ q1AnsweredCount }} / {{ q1ActiveQuestions.length }} answered</span>
              </div>
              <div class="c1-hp"></div>
              <button
                v-if="q1QIdx < q1ActiveQuestions.length - 1"
                class="q1-btn q1-btn-take"
                @click="q1NextQ"
              >
                {{ q1UserAnswers[q1QIdx] === null ? 'Skip' : 'Next' }}
                <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
              </button>
              <button
                v-else
                class="q1-btn q1-btn-submit"
                @click="q1SubmitQuiz"
                :disabled="q1Submitting"
              >
                <span v-if="q1Submitting">Submitting…</span>
                <span v-else>Submit quiz</span>
              </button>
            </div>
          </template>

          <!-- REVIEW RESULTS MODE -->
          <template v-else-if="q1DrawerMode === 'results'">
            <div class="q1-dr-head">
              <div class="q1-dr-title">{{ q1ActiveQuiz ? q1ActiveQuiz.title : '' }}</div>
              <div class="q1-dr-sub">Results review</div>
              <button class="q1-dr-close" @click="q1CloseDrawer">
                <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>

            <div class="q1-dr-body">
              <!-- Score summary -->
              <div class="q1-res-summary">
                <div class="q1-score-circle" :class="q1ActiveQuiz && q1ActiveQuiz.myScore >= q1ActiveQuiz.passThreshold ? 'pass' : 'fail'">
                  <div class="q1-sc-pct">{{ q1ActiveQuiz ? q1ActiveQuiz.myScore : 0 }}%</div>
                  <div class="q1-sc-lbl">{{ q1ActiveQuiz && q1ActiveQuiz.myScore >= q1ActiveQuiz.passThreshold ? 'PASSED' : 'FAILED' }}</div>
                </div>
                <div class="q1-score-stats-grid" style="width:100%;margin-top:12px">
                  <div class="q1-ss-item">
                    <div class="q1-ss-val" style="color:#22c55e">{{ q1ReviewCorrectCount }}</div>
                    <div class="q1-ss-lbl">Correct</div>
                  </div>
                  <div class="q1-ss-item">
                    <div class="q1-ss-val" style="color:#ef4444">{{ q1ActiveQuestions.length - q1ReviewCorrectCount }}</div>
                    <div class="q1-ss-lbl">Wrong</div>
                  </div>
                  <div class="q1-ss-item">
                    <div class="q1-ss-val q1-mono">{{ q1ActiveQuiz && q1ActiveQuiz.timeTaken ? q1FmtTimer(q1ActiveQuiz.timeTaken) : '—' }}</div>
                    <div class="q1-ss-lbl">Time</div>
                  </div>
                  <div class="q1-ss-item">
                    <div class="q1-ss-val q1-mono">{{ q1ActiveQuiz ? q1FmtDate(q1ActiveQuiz.dateTaken) : '—' }}</div>
                    <div class="q1-ss-lbl">Date</div>
                  </div>
                </div>
              </div>

              <!-- Per-question review -->
              <div class="q1-review-list">
                <div v-for="(q, qi) in q1ActiveQuestions" :key="qi" class="q1-rev-q">
                  <div class="q1-rev-q-hdr">
                    <span class="q1-rev-num">Q{{ qi + 1 }}</span>
                    <span class="q1-rev-text">{{ q.text }}</span>
                    <svg v-if="q1PastAnswers[qi] !== undefined && q.answers[q1PastAnswers[qi]] && q.answers[q1PastAnswers[qi]].correct"
                      class="q1-rev-ico correct" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                    <svg v-else class="q1-rev-ico wrong" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </div>
                  <div class="q1-rev-answers">
                    <div
                      v-for="(ans, ai) in q.answers"
                      :key="ai"
                      class="q1-rev-ans"
                      :class="{
                        correct: ans.correct,
                        selected: q1PastAnswers[qi] === ai && !ans.correct
                      }"
                    >
                      <span class="q1-ans-letter">{{ String.fromCharCode(65 + ai) }}</span>
                      {{ ans.text }}
                      <span v-if="ans.correct" class="q1-rev-correct-tag">correct</span>
                      <span v-if="q1PastAnswers[qi] === ai && !ans.correct" class="q1-rev-your-tag">your answer</span>
                    </div>
                  </div>
                  <div v-if="q.explanation" class="q1-explanation q1-exp-sm">
                    <div class="q1-exp-lbl">Explanation</div>
                    <div class="q1-exp-text">{{ q.explanation }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="q1-dr-foot">
              <button class="q1-btn q1-btn-ghost" style="flex:1" @click="q1CloseDrawer">Close</button>
              <button class="q1-btn q1-btn-take" style="flex:1" @click="q1ShareResult">
                <svg viewBox="0 0 24 24"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                Share result
              </button>
            </div>
          </template>

        </div>
      </div>
    </transition>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- CONFIRM EXIT MODAL                                 -->
    <!-- ══════════════════════════════════════════════════ -->
    <transition name="q1-fade">
      <div v-if="q1ConfirmExitOpen" class="q1-modal-wrap" @click.self="q1ConfirmExitOpen = false">
        <div class="q1-modal">
          <div class="q1-modal-title">Exit quiz?</div>
          <div class="q1-modal-body">Your progress will be lost. You can retake the quiz later.</div>
          <div class="q1-modal-actions">
            <button class="q1-btn q1-btn-ghost" @click="q1ConfirmExitOpen = false">Keep going</button>
            <button class="q1-btn q1-btn-danger-solid" @click="q1ForceCloseDrawer">Exit quiz</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- ══════════════════════════════════════════════════ -->
    <!-- QUIZ BUILDER DRAWER (slides from LEFT)             -->
    <!-- ══════════════════════════════════════════════════ -->
    <transition name="q1-ldrawer">
      <div v-if="q1CreateOpen" class="q1-drawer-wrap q1-ldrawer-wrap" @click.self="q1CreateOpen = false">
        <div class="q1-drawer q1-create-drawer">
          <div class="q1-dr-head">
            <div class="q1-dr-title">{{ q1EditMode ? 'Edit quiz' : 'Create new quiz' }}</div>
            <div class="q1-dr-sub">{{ q1EditMode ? 'Update settings and questions' : 'Configure settings and add questions' }}</div>
            <button class="q1-dr-close" @click="q1CreateOpen = false">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <!-- Builder tabs -->
          <div class="q1-builder-tabs">
            <div class="q1-bt" :class="{ on: q1BuilderTab === 'settings' }" @click="q1BuilderTab = 'settings'">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
              Settings
            </div>
            <div class="q1-bt" :class="{ on: q1BuilderTab === 'questions' }" @click="q1BuilderTab = 'questions'">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              Questions
              <span v-if="q1CreateForm.questions.length" class="q1-bt-badge">{{ q1CreateForm.questions.length }}</span>
            </div>
            <div class="q1-bt" :class="{ on: q1BuilderTab === 'assign' }" @click="q1BuilderTab = 'assign'">
              <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
              Assign
            </div>
          </div>

          <div class="q1-dr-body">

            <!-- SETTINGS TAB -->
            <template v-if="q1BuilderTab === 'settings'">
              <div class="q1-form-group">
                <label class="q1-form-lbl">Quiz title *</label>
                <input class="q1-form-input" v-model.trim="q1CreateForm.title" placeholder="e.g. Compliance Fundamentals Q1" />
              </div>
              <div class="q1-form-group">
                <label class="q1-form-lbl">Description</label>
                <textarea class="q1-form-input q1-form-textarea" v-model.trim="q1CreateForm.description" placeholder="Short description of what this quiz covers…" rows="3"></textarea>
              </div>
              <div class="q1-form-group">
                <label class="q1-form-lbl">Category *</label>
                <div class="c1-fp-opts">
                  <div v-for="cat in q1Categories" :key="cat" class="c1-fp-opt"
                    :class="{ on: q1CreateForm.category === cat }"
                    @click="q1CreateForm.category = cat">{{ cat }}</div>
                </div>
              </div>
              <div class="q1-form-row3">
                <div class="q1-form-group">
                  <label class="q1-form-lbl">Pass threshold (%)</label>
                  <input class="q1-form-input" type="number" v-model.number="q1CreateForm.passThreshold" min="1" max="100" />
                </div>
                <div class="q1-form-group">
                  <label class="q1-form-lbl">Time limit (min)</label>
                  <input class="q1-form-input" type="number" v-model.number="q1CreateForm.timeLimit" min="0" placeholder="0 = no limit" />
                </div>
                <div class="q1-form-group">
                  <label class="q1-form-lbl">Max attempts</label>
                  <input class="q1-form-input" type="number" v-model.number="q1CreateForm.maxAttempts" min="1" placeholder="∞" />
                </div>
              </div>
              <div class="q1-form-group">
                <label class="q1-form-lbl">Due date</label>
                <input class="q1-form-input" type="date" v-model="q1CreateForm.dueDate" />
              </div>
              <div class="q1-form-group">
                <label class="q1-form-lbl">Status</label>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: q1CreateForm.quizStatus === 'active' }" @click="q1CreateForm.quizStatus = 'active'">Active</div>
                  <div class="c1-fp-opt" :class="{ on: q1CreateForm.quizStatus === 'draft' }" @click="q1CreateForm.quizStatus = 'draft'">Draft</div>
                </div>
              </div>
            </template>

            <!-- QUESTIONS TAB -->
            <template v-if="q1BuilderTab === 'questions'">
              <div class="q1-qs-hdr">
                <span class="q1-form-lbl" style="margin:0">Questions ({{ q1CreateForm.questions.length }})</span>
                <div class="q1-qs-hdr-btns">
                  <button class="q1-btn q1-btn-ghost q1-btn-sm" @click="q1AddQuestion('multiple_choice')">+ MC</button>
                  <button class="q1-btn q1-btn-ghost q1-btn-sm" @click="q1AddQuestion('true_false')">+ T/F</button>
                </div>
              </div>

              <div v-if="q1CreateForm.questions.length === 0" class="q1-no-questions">
                Click + MC or + T/F to add your first question
              </div>

              <div
                v-for="(q, qi) in q1CreateForm.questions"
                :key="qi"
                class="q1-create-q"
                :class="{ dragging: q1DragIdx === qi }"
                draggable="true"
                @dragstart="q1DragStart(qi)"
                @dragover.prevent="q1DragOver(qi)"
                @drop="q1DragDrop(qi)"
                @dragend="q1DragEnd"
              >
                <div class="q1-cq-hdr">
                  <div class="q1-cq-drag-handle">
                    <svg viewBox="0 0 24 24"><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/></svg>
                  </div>
                  <span class="q1-rev-num">Q{{ qi + 1 }}</span>
                  <span class="q1-cq-type-badge">{{ q.type === 'true_false' ? 'T/F' : 'MC' }}</span>
                  <input class="q1-form-input q1-cq-input" v-model.trim="q.text" placeholder="Question text…" />
                  <button class="q1-cq-del" @click="q1RemoveQuestion(qi)" title="Remove question">
                    <svg viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>
                  </button>
                </div>

                <!-- MC options -->
                <div v-if="q.type !== 'true_false'" class="q1-cq-answers">
                  <div v-for="(ans, ai) in q.answers" :key="ai" class="q1-cq-ans-row">
                    <input
                      type="radio"
                      :name="'correct-' + qi"
                      :checked="ans.correct"
                      @change="q1SetCorrect(qi, ai)"
                      class="q1-cq-radio"
                    />
                    <span class="q1-cq-ans-letter">{{ String.fromCharCode(65 + ai) }}</span>
                    <input class="q1-form-input q1-cq-ans-input" v-model.trim="ans.text" :placeholder="'Answer ' + String.fromCharCode(65 + ai)" />
                    <button v-if="q.answers.length > 2" class="q1-cq-ans-del" @click="q1RemoveAnswer(qi, ai)">
                      <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    </button>
                  </div>
                  <button v-if="q.answers.length < 4" class="q1-btn q1-btn-ghost q1-btn-sm" @click="q1AddAnswer(qi)" style="margin-top:4px">+ Answer</button>
                </div>

                <!-- T/F options -->
                <div v-else class="q1-cq-answers">
                  <div class="q1-cq-ans-row">
                    <input type="radio" :name="'correct-' + qi" :checked="q.answers[0] && q.answers[0].correct" @change="q1SetCorrect(qi, 0)" class="q1-cq-radio" />
                    <span class="q1-cq-tf-lbl">True</span>
                  </div>
                  <div class="q1-cq-ans-row">
                    <input type="radio" :name="'correct-' + qi" :checked="q.answers[1] && q.answers[1].correct" @change="q1SetCorrect(qi, 1)" class="q1-cq-radio" />
                    <span class="q1-cq-tf-lbl">False</span>
                  </div>
                </div>

                <!-- Explanation -->
                <div class="q1-cq-exp-row">
                  <div class="q1-form-lbl" style="margin-bottom:4px">Explanation (optional)</div>
                  <input class="q1-form-input" v-model.trim="q.explanation" placeholder="Shown after quiz to explain correct answer…" />
                </div>
              </div>
            </template>

            <!-- ASSIGN TAB -->
            <template v-if="q1BuilderTab === 'assign'">
              <div class="c1-fp-group c1-fp-full">
                <div class="c1-fp-lbl">Assign to</div>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: q1CreateForm.assignTo === 'all' }" @click="q1CreateForm.assignTo = 'all'">All agents</div>
                  <div class="c1-fp-opt" :class="{ on: q1CreateForm.assignTo === 'specific' }" @click="q1CreateForm.assignTo = 'specific'">Specific agents</div>
                </div>
              </div>
              <div v-if="q1CreateForm.assignTo === 'specific'" style="margin-top:12px">
                <div class="c1-fp-lbl">Select agents</div>
                <div class="c1-agent-grid">
                  <div
                    v-for="user in q1UserList"
                    :key="user.id"
                    class="c1-agent-chip"
                    :class="{ on: q1CreateForm.assignedUsers.includes(user.id) }"
                    @click="q1ToggleAssignUser(user.id)"
                  >
                    <div class="c1-agent-av">{{ q1AgentInitials(user) }}</div>
                    <span class="c1-agent-nm">{{ user.first_name }} {{ user.last_name }}</span>
                  </div>
                </div>
              </div>
              <div class="c1-fp-group c1-fp-full" style="margin-top:16px">
                <div class="c1-fp-lbl">Send Viki notification</div>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: q1CreateForm.sendViki }" @click="q1CreateForm.sendViki = true">Yes</div>
                  <div class="c1-fp-opt" :class="{ on: !q1CreateForm.sendViki }" @click="q1CreateForm.sendViki = false">No</div>
                </div>
              </div>
            </template>

          </div>

          <div class="q1-dr-foot">
            <button class="q1-btn q1-btn-ghost" @click="q1CreateOpen = false">Cancel</button>
            <div class="c1-hp"></div>
            <button class="q1-btn q1-btn-ghost q1-btn-sm" v-if="q1BuilderTab !== 'settings'" @click="q1BuilderTab = q1BuilderTab === 'questions' ? 'settings' : 'questions'">
              <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
              Back
            </button>
            <button class="q1-btn q1-btn-ghost q1-btn-sm" v-if="q1BuilderTab !== 'assign'" @click="q1BuilderTab = q1BuilderTab === 'settings' ? 'questions' : 'assign'">
              Next
              <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
            <button
              v-if="q1BuilderTab === 'assign'"
              class="q1-btn q1-btn-submit"
              :disabled="!q1CreateForm.title || !q1CreateForm.category || q1CreateForm.questions.length === 0 || q1CreateSaving"
              @click="q1SaveQuiz"
            >
              <span v-if="q1CreateSaving">Saving…</span>
              <span v-else>{{ q1EditMode ? 'Update quiz' : 'Save quiz' }}</span>
            </button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

const API_BASE = '/api';

function apiGet(endpoint) {
  const token = localStorage.getItem('user-token');
  return fetch(`${API_BASE}/${endpoint}`, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(r => r.json());
}
function apiPost(endpoint, body) {
  const token = localStorage.getItem('user-token');
  return fetch(`${API_BASE}/${endpoint}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).then(r => r.json());
}

export default {
  name: 'Quiz1Container',

  components: { VikiFace, C1ModCalendar },

  data() {
    const now = new Date();
    return {
      c1Status: 'shift',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      // ── UI state ──────────────────────────────────────
      c1TopTab: null,
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      q1UserOnline: true,
      q1SlideOpen: null,
      q1PanelActiveContent: null,
      q1View: 'my',
      q1Loading: false,
      q1AllUsersLoading: false,
      q1ExpandedExam: null,
      q1ExpandedUser: null,
      q1FilterTab: 'status',
      q1BuilderTab: 'settings',
      q1SearchText: '',
      q1SelectedQuizId: null,
      q1ScoreboardQuizId: null,

      // ── Settings ──────────────────────────────────────
      q1Settings: {
        defaultPassThreshold: 70,
        defaultTimeLimit: 30,
        defaultMaxAttempts: 3,
        notifyOnFail: true,
        mandatoryQuizzes: false,
        instructionText: '',
        categories: ['Compliance', 'Product Knowledge', 'Sales Skills', 'Onboarding'],
      },
      q1SettingsSaving: false,
      q1NewCategory: '',

      // ── Toast ─────────────────────────────────────────
      q1Toast: null,
      q1ToastTimer: null,

      // ── Filters ───────────────────────────────────────
      q1Filter: {
        status: null,
        result: null,
        category: null,
        assigned: null,
        userId: null,
        due: 'all',
        scoreMin: 0,
        scoreMax: 100,
        createdFrom: '',
        createdTo: ''
      },

      q1Categories: ['Compliance', 'Sales', 'Product', 'Security', 'HR', 'Finance'],

      // ── Calendar ──────────────────────────────────────
      q1Cal: { year: now.getFullYear(), month: now.getMonth() },
      q1CalMonthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],

      // ── Charts data ───────────────────────────────────
      q1ScoreBars: [
        { label: '0–20', pct: 8,  color: '#ef4444' },
        { label: '21–40', pct: 15, color: '#f97316' },
        { label: '41–60', pct: 30, color: '#f59e0b' },
        { label: '61–80', pct: 65, color: '#84cc16' },
        { label: '81–100', pct: 100, color: '#22c55e' }
      ],
      q1TrendBars: [
        { label: 'W1', pct: 40, val: 4 },
        { label: 'W2', pct: 55, val: 6 },
        { label: 'W3', pct: 45, val: 5 },
        { label: 'W4', pct: 70, val: 8 },
        { label: 'W5', pct: 60, val: 7 },
        { label: 'W6', pct: 90, val: 10 }
      ],
      q1QuizPassBars: [
        { label: 'Compliance Fundamentals', short: 'Comp', pct: 72, color: '#22c55e' },
        { label: 'Sales Techniques Advanced', short: 'Sales', pct: 88, color: '#22c55e' },
        { label: 'Product Knowledge Q1', short: 'Prod', pct: 55, color: '#f59e0b' },
        { label: 'Security Awareness', short: 'Sec', pct: 91, color: '#22c55e' }
      ],
      q1TimeBars: [
        { label: 'Compliance Fundamentals', short: 'Comp', pct: 60, val: 12 },
        { label: 'Sales Techniques Advanced', short: 'Sales', pct: 40, val: 8 },
        { label: 'Product Knowledge Q1', short: 'Prod', pct: 80, val: 16 },
        { label: 'Security Awareness', short: 'Sec', pct: 35, val: 7 }
      ],

      // ── Quiz list data ────────────────────────────────
      q1Quizzes: [
        {
          id: 1,
          title: 'Compliance Fundamentals',
          category: 'Compliance',
          description: 'Core compliance rules and regulatory requirements for all staff. Mandatory annual assessment.',
          questionCount: 3,
          timeLimit: 20,
          passThreshold: 75,
          maxAttempts: 3,
          attemptsRemaining: 2,
          dueDate: '2026-04-05',
          myStatus: 'failed',
          myScore: 60,
          avgScore: 72,
          timeTaken: 743,
          dateTaken: '2026-03-25T10:30:00Z',
          createdAt: '2026-01-10T09:00:00Z',
          assignedTo: 'All agents',
          quizStatus: 'active',
          attempts: [
            { score: 60, timeTaken: 743, date: '2026-03-25T10:30:00Z' }
          ],
          questions: [
            {
              text: 'Which regulation governs data protection in the EU?',
              type: 'multiple_choice',
              explanation: 'GDPR (General Data Protection Regulation) is the primary EU data protection law, effective since May 2018.',
              answers: [
                { text: 'HIPAA', correct: false },
                { text: 'GDPR', correct: true },
                { text: 'SOX', correct: false },
                { text: 'PCI-DSS', correct: false }
              ]
            },
            {
              text: 'How long must client records be retained by default under MiFID II?',
              type: 'multiple_choice',
              explanation: 'MiFID II requires firms to retain records for at least 5 years (7 years in some cases).',
              answers: [
                { text: '1 year', correct: false },
                { text: '3 years', correct: false },
                { text: '5 years', correct: true },
                { text: '10 years', correct: false }
              ]
            },
            {
              text: 'A suspicious transaction should be reported to the compliance officer immediately.',
              type: 'true_false',
              explanation: 'Yes — AML policies require immediate escalation to compliance when suspicious activity is identified.',
              answers: [
                { text: 'True', correct: true },
                { text: 'False', correct: false }
              ]
            }
          ]
        },
        {
          id: 2,
          title: 'Sales Techniques Advanced',
          category: 'Sales',
          description: 'Advanced sales frameworks, objection handling and closing strategies for senior agents.',
          questionCount: 2,
          timeLimit: 15,
          passThreshold: 70,
          maxAttempts: null,
          attemptsRemaining: null,
          dueDate: '2026-04-15',
          myStatus: 'passed',
          myScore: 85,
          avgScore: 88,
          timeTaken: 420,
          dateTaken: '2026-03-20T14:00:00Z',
          createdAt: '2026-01-15T09:00:00Z',
          assignedTo: 'All agents',
          quizStatus: 'active',
          attempts: [
            { score: 85, timeTaken: 420, date: '2026-03-20T14:00:00Z' }
          ],
          questions: [
            {
              text: 'What does the SPIN selling acronym stand for?',
              type: 'multiple_choice',
              explanation: 'SPIN = Situation, Problem, Implication, Need-payoff. Developed by Neil Rackham.',
              answers: [
                { text: 'Situation, Problem, Implication, Need-payoff', correct: true },
                { text: 'Speed, Price, Interest, Negotiation', correct: false },
                { text: 'Strategy, Plan, Influence, Network', correct: false },
                { text: 'None of the above', correct: false }
              ]
            },
            {
              text: 'The summary close involves restating benefits before asking for the sale.',
              type: 'true_false',
              explanation: 'True — the summary close reinforces value by recapping agreed benefits before the commitment ask.',
              answers: [
                { text: 'True', correct: true },
                { text: 'False', correct: false }
              ]
            }
          ]
        },
        {
          id: 3,
          title: 'Product Knowledge Q1 2026',
          category: 'Product',
          description: 'Current product suite, pricing tiers and key differentiators for Q1 2026.',
          questionCount: 2,
          timeLimit: 30,
          passThreshold: 80,
          maxAttempts: 2,
          attemptsRemaining: 2,
          dueDate: '2026-04-01',
          myStatus: 'not_taken',
          myScore: null,
          avgScore: 55,
          timeTaken: null,
          dateTaken: null,
          createdAt: '2026-02-01T09:00:00Z',
          assignedTo: 'All agents',
          quizStatus: 'active',
          attempts: [],
          questions: [
            {
              text: 'What is the name of our entry-level subscription plan?',
              type: 'multiple_choice',
              explanation: 'The Starter plan is our lowest tier, offering core CRM features at a competitive price.',
              answers: [
                { text: 'Starter', correct: true },
                { text: 'Basic', correct: false },
                { text: 'Lite', correct: false },
                { text: 'Core', correct: false }
              ]
            },
            {
              text: 'API access is available on all plans including the entry-level Starter plan.',
              type: 'true_false',
              explanation: 'False — API access is only available on Pro and Enterprise plans.',
              answers: [
                { text: 'True', correct: false },
                { text: 'False', correct: true }
              ]
            }
          ]
        },
        {
          id: 4,
          title: 'Security Awareness',
          category: 'Security',
          description: 'Phishing awareness, password hygiene and safe data handling practices.',
          questionCount: 2,
          timeLimit: 15,
          passThreshold: 70,
          maxAttempts: null,
          attemptsRemaining: null,
          dueDate: '2026-04-20',
          myStatus: 'pending',
          myScore: null,
          avgScore: 91,
          timeTaken: null,
          dateTaken: null,
          createdAt: '2026-02-10T09:00:00Z',
          assignedTo: 'All agents',
          quizStatus: 'active',
          attempts: [],
          questions: [
            {
              text: 'Which of these is considered a strong password?',
              type: 'multiple_choice',
              explanation: 'A strong password is long, uses mixed characters, and avoids dictionary words.',
              answers: [
                { text: 'password123', correct: false },
                { text: 'Tr0ub4dor&3', correct: true },
                { text: 'qwerty', correct: false },
                { text: '123456', correct: false }
              ]
            },
            {
              text: 'You should always verify the sender before clicking links in emails.',
              type: 'true_false',
              explanation: 'True — phishing attacks often spoof trusted senders to trick employees into clicking malicious links.',
              answers: [
                { text: 'True', correct: true },
                { text: 'False', correct: false }
              ]
            }
          ]
        }
      ],

      // ── All-users view ────────────────────────────────
      q1AllUserRows: [],

      // ── User list (for filters / assign) ─────────────
      q1UserList: [
        { id: 101, first_name: 'Sarah', last_name: 'Cohen' },
        { id: 102, first_name: 'James', last_name: 'Miller' },
        { id: 103, first_name: 'Dani',  last_name: 'Levy' },
        { id: 104, first_name: 'Anna',  last_name: 'Katz' },
        { id: 105, first_name: 'Yoav',  last_name: 'Ben-David' }
      ],

      // ── Quiz taking state ─────────────────────────────
      q1DrawerOpen: false,
      q1DrawerMode: 'take',
      q1ActiveQuiz: null,
      q1ActiveQuestions: [],
      q1QIdx: 0,
      q1UserAnswers: [],
      q1PastAnswers: [],
      q1AnswerRevealed: false,
      q1ShowScore: false,
      q1FinalScore: 0,
      q1TimeTaken: 0,
      q1StartTime: null,
      q1TimerActive: false,
      q1TimeLeft: 0,
      q1TimerInterval: null,
      q1Submitting: false,
      q1ConfirmExitOpen: false,

      // ── Builder state ─────────────────────────────────
      q1CreateOpen: false,
      q1CreateSaving: false,
      q1EditMode: false,
      q1EditingId: null,
      q1DragIdx: null,
      q1DragOverIdx: null,
      q1CreateForm: {
        title: '',
        description: '',
        category: null,
        passThreshold: 75,
        timeLimit: 0,
        maxAttempts: null,
        dueDate: '',
        quizStatus: 'active',
        questions: [],
        assignTo: 'all',
        assignedUsers: [],
        sendViki: true
      },

      // ── Viki ──────────────────────────────────────────
      q1VikiMessages: [
        { id: 1, type: 'info',    text: 'New quiz assigned: Compliance Fundamentals', ts: new Date(Date.now() - 3600000*2).toISOString(), read: false },
        { id: 2, type: 'warning', text: 'Reminder: You haven\'t completed Product Knowledge Q1 2026 yet. Due today!', ts: new Date(Date.now() - 3600000*5).toISOString(), read: false },
        { id: 3, type: 'success', text: 'Congratulations! You scored 85% on Sales Techniques Advanced.', ts: new Date(Date.now() - 86400000).toISOString(), read: true }
      ]
    };
  },

  computed: {
    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return [u.first_name, u.last_name].filter(Boolean).join(" ") || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "";
      const map = { admin: "Admin", manager: "Manager", agent: "Agent", broker: "Broker" };
      return map[u.role] || u.role || "";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },

    q1PanelIsOpen() {
      return !!this.q1SlideOpen && this.q1SlideOpen !== 'menu';
    },
    q1PanelAtContent() {
      return this.q1PanelIsOpen && this.q1SlideOpen !== 'nav';
    },
    q1ActivePanelLabel() {
      if (!this.q1PanelIsOpen || this.q1SlideOpen === 'nav') return 'Panels';
      return this.q1PanelActiveContent ? (this.q1PanelActiveContent.charAt(0).toUpperCase() + this.q1PanelActiveContent.slice(1)) : 'Panels';
    },

    q1AuthUser() {
      return (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user) || {};
    },
    q1UserInitials() {
      const u = this.q1AuthUser;
      return (((u.first_name || '')[0]) || '').toUpperCase() +
             (((u.last_name  || '')[0]) || '').toUpperCase() || '?';
    },
    q1IsManager() {
      return [1, 2, 3, 12].includes(this.q1AuthUser.role);
    },

    // Active filter count
    q1ActiveFilterCount() {
      let n = 0;
      if (this.q1Filter.status)   n++;
      if (this.q1Filter.result)   n++;
      if (this.q1Filter.category) n++;
      if (this.q1Filter.assigned) n++;
      if (this.q1Filter.userId)   n++;
      if (this.q1Filter.due !== 'all') n++;
      if (this.q1Filter.scoreMin > 0 || this.q1Filter.scoreMax < 100) n++;
      if (this.q1Filter.createdFrom || this.q1Filter.createdTo) n++;
      return n;
    },

    // Filtered quiz list
    q1FilteredQuizzes() {
      return this.q1Quizzes.filter(q => {
        if (this.q1SearchText) {
          const s = this.q1SearchText.toLowerCase();
          if (!q.title.toLowerCase().includes(s) && !q.category.toLowerCase().includes(s)) return false;
        }
        if (this.q1Filter.status && q.quizStatus !== this.q1Filter.status) return false;
        if (this.q1Filter.result && q.myStatus !== this.q1Filter.result) return false;
        if (this.q1Filter.category && q.category !== this.q1Filter.category) return false;
        if (this.q1Filter.scoreMin > 0 || this.q1Filter.scoreMax < 100) {
          if (q.myScore !== null) {
            if (q.myScore < this.q1Filter.scoreMin || q.myScore > this.q1Filter.scoreMax) return false;
          }
        }
        if (this.q1Filter.due !== 'all' && q.dueDate) {
          const now = new Date();
          const due = new Date(q.dueDate);
          if (this.q1Filter.due === 'overdue' && due >= now) return false;
          if (this.q1Filter.due === 'today') {
            const todayStr = now.toISOString().slice(0,10);
            if (q.dueDate.slice(0,10) !== todayStr) return false;
          }
          if (this.q1Filter.due === 'this_week') {
            const weekEnd = new Date(now); weekEnd.setDate(now.getDate() + 7);
            if (due < now || due > weekEnd) return false;
          }
          if (this.q1Filter.due === 'this_month') {
            if (due.getMonth() !== now.getMonth() || due.getFullYear() !== now.getFullYear()) return false;
          }
        }
        return true;
      });
    },

    // Stats from quiz list
    q1Stats() {
      const exams = this.q1Quizzes;
      const completed = exams.filter(e => e.myStatus === 'passed' || e.myStatus === 'failed').length;
      const passed    = exams.filter(e => e.myStatus === 'passed').length;
      const failed    = exams.filter(e => e.myStatus === 'failed').length;
      const pending   = exams.filter(e => e.myStatus === 'pending' || e.myStatus === 'not_taken').length;
      const scored    = exams.filter(e => e.myScore !== null);
      const avgScore  = scored.length ? Math.round(scored.reduce((s, e) => s + e.myScore, 0) / scored.length) : 0;
      const passRate  = completed ? Math.round((passed / completed) * 100) : 0;
      return { completed, passed, failed, pending, avgScore, passRate };
    },

    q1MyKpis() {
      const s = this.q1Stats;
      return [
        { label: 'Pass rate',  val: s.passRate + '%',  color: '#22c55e' },
        { label: 'Completed',  val: s.completed,       color: '#6366f1' },
        { label: 'Passed',     val: s.passed,          color: '#22c55e' },
        { label: 'Pending',    val: s.pending,         color: '#f59e0b' }
      ];
    },

    // Upcoming due exams for calendar panel
    q1UpcomingDue() {
      const now = new Date();
      const limit = new Date(now); limit.setDate(now.getDate() + 14);
      return this.q1Quizzes
        .filter(q => q.dueDate && (new Date(q.dueDate) < limit) && q.myStatus !== 'passed')
        .sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate))
        .slice(0, 6);
    },

    // Calendar grid
    q1CalGrid() {
      const { year, month } = this.q1Cal;
      const firstDay  = new Date(year, month, 1);
      const startDow  = (firstDay.getDay() + 6) % 7;
      const cells     = [];
      const cursor    = new Date(firstDay);
      cursor.setDate(cursor.getDate() - startDow);
      const todayStr  = new Date().toISOString().slice(0, 10);
      const examDates = new Set(this.q1Quizzes.filter(e => e.dateTaken).map(e => e.dateTaken.slice(0, 10)));
      const dueDates  = new Set(this.q1Quizzes.map(e => e.dueDate).filter(Boolean));
      for (let i = 0; i < 42; i++) {
        const dateStr = cursor.toISOString().slice(0, 10);
        cells.push({
          date: dateStr,
          day: cursor.getDate(),
          inMonth: cursor.getMonth() === month,
          today: dateStr === todayStr,
          hasExam: examDates.has(dateStr),
          isDue: dueDates.has(dateStr)
        });
        cursor.setDate(cursor.getDate() + 1);
        if (i >= 27 && cursor.getMonth() !== month) break;
      }
      return cells;
    },

    // Team KPIs for all-users view
    q1TeamKpis() {
      const rows = this.q1AllUserRows;
      if (!rows.length) return [];
      const total    = rows.length;
      const avgRate  = Math.round(rows.reduce((s, r) => s + r.passRate, 0) / total);
      const allPass  = rows.reduce((s, r) => s + r.passed, 0);
      const allPend  = rows.reduce((s, r) => s + r.pending, 0);
      return [
        { label: 'Members',    val: total,          color: '#6366f1' },
        { label: 'Avg rate',   val: avgRate + '%',  color: '#22c55e' },
        { label: 'Passed',     val: allPass,        color: '#22c55e' },
        { label: 'Pending',    val: allPend,        color: '#f59e0b' }
      ];
    },

    // Filtered user rows (by selected quiz)
    q1FilteredUserRows() {
      if (!this.q1SelectedQuizId) return this.q1AllUserRows;
      return this.q1AllUserRows.map(row => ({
        ...row,
        exams: row.exams.filter(e => e.id === this.q1SelectedQuizId)
      })).filter(row => row.exams.length > 0);
    },

    // Scoreboard rows sorted by best score
    q1ScoreboardRows() {
      return this.q1AllUserRows
        .map(row => {
          const exams = this.q1ScoreboardQuizId
            ? row.exams.filter(e => e.id === this.q1ScoreboardQuizId)
            : row.exams;
          const scores = exams.filter(e => e.score !== null).map(e => e.score);
          const times  = exams.filter(e => e.timeTaken).map(e => e.timeTaken);
          return {
            ...row,
            bestScore: scores.length ? Math.max(...scores) : 0,
            avgTime:   times.length ? Math.round(times.reduce((a, b) => a + b, 0) / times.length) : null,
            attempts:  exams.length
          };
        })
        .filter(r => r.bestScore > 0)
        .sort((a, b) => b.bestScore - a.bestScore);
    },

    // Correct count during quiz taking
    q1CorrectCount() {
      return this.q1ActiveQuestions.reduce((count, q, i) => {
        const chosen = this.q1UserAnswers[i];
        if (chosen !== null && q.answers[chosen] && q.answers[chosen].correct) return count + 1;
        return count;
      }, 0);
    },

    // Wrong answers list for post-quiz review
    q1WrongAnswers() {
      return this.q1ActiveQuestions.reduce((list, q, i) => {
        const chosen = this.q1UserAnswers[i];
        if (chosen === null || !q.answers[chosen] || !q.answers[chosen].correct) {
          list.push({ qIdx: i, text: q.text, answers: q.answers, chosen, explanation: q.explanation });
        }
        return list;
      }, []);
    },

    // Answered count during quiz
    q1AnsweredCount() {
      return this.q1UserAnswers.filter(a => a !== null).length;
    },

    // Review mode correct count (from past answers)
    q1ReviewCorrectCount() {
      return this.q1ActiveQuestions.reduce((count, q, i) => {
        const chosen = this.q1PastAnswers[i];
        if (chosen !== undefined && q.answers[chosen] && q.answers[chosen].correct) return count + 1;
        return count;
      }, 0);
    },

    // Viki unread count
    q1VikiUnread() {
      return this.q1VikiMessages.filter(m => !m.read).length;
    }
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) {
      sessionStorage.removeItem('c1keepNav');
      this.q1SlideOpen = 'nav';
      this.c1NavMode = 'panels';
    }
    sessionStorage.removeItem('c1openPanel');
  },

  mounted() {
    document.documentElement.style.setProperty('--gnm-sw', '0px');
    this.q1FetchQuizzes();
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
  },

  beforeDestroy() {
    this.q1ClearTimer();
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
  },

  watch: {
    'q1SlideOpen': function(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.q1PanelActiveContent = val;
      }
    }
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },

    // ── Panel management ────────────────────────────────
    q1PanelBtnClick() {
      this.q1SlideOpen = this.q1PanelIsOpen ? null : 'nav';
    },
    q1SelectPanel(panel) {
      this.q1SlideOpen = panel;
    },
    q1FilterPanelClick(e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    q1OpenSlide(name) {
      this.q1SlideOpen = this.q1SlideOpen === name ? null : name;
    },

    // ── Data fetching ───────────────────────────────────
    q1FetchQuizzes() {
      this.q1Loading = true;
      // Backend route: GET users/questions_user_exam/{exam_type}
      apiGet('users/questions_user_exam/all').then(res => {
        if (res && res.data) {
          // Map backend response to local quiz format if available
          const data = Array.isArray(res.data) ? res.data : (res.data.data || []);
          if (data.length) this.q1Quizzes = data;
        }
      }).catch(() => {}).finally(() => { this.q1Loading = false; });
    },

    q1FetchQuestions(quizId) {
      // Backend route: GET users/questions_user_exam/{exam_type}
      return apiGet(`users/questions_user_exam/${quizId}`).then(res => {
        if (res && res.data) {
          const data = Array.isArray(res.data) ? res.data : (res.data.data || []);
          if (data.length) return data;
        }
        const quiz = this.q1Quizzes.find(q => q.id === quizId);
        return quiz ? quiz.questions : [];
      }).catch(() => {
        const quiz = this.q1Quizzes.find(q => q.id === quizId);
        return quiz ? quiz.questions : [];
      });
    },

    q1FetchScores() {
      // Backend route: GET users/games (scores embedded in game data)
      apiGet('users/games').catch(() => {});
    },

    q1SwitchToAll() {
      this.q1View = 'all';
      if (!this.q1AllUserRows.length) this.q1LoadAllUsers();
    },

    q1SwitchToScoreboard() {
      this.q1View = 'scoreboard';
      if (!this.q1AllUserRows.length) this.q1LoadAllUsers();
    },

    q1LoadAllUsers() {
      if (this.q1AllUserRows.length) return;
      this.q1AllUsersLoading = true;
      // Real API: apiGet('quiz/scores').then(res => { this.q1AllUserRows = res; })
      setTimeout(() => {
        this.q1AllUserRows = [
          {
            userId: 101, first_name: 'Sarah', last_name: 'Cohen',
            passed: 4, failed: 1, pending: 1, passRate: 80, avgTime: 380,
            exams: [
              { id: 1, title: 'Compliance Fundamentals', category: 'Compliance', status: 'passed', score: 82, passThreshold: 75, timeTaken: 540 },
              { id: 2, title: 'Sales Techniques Advanced', category: 'Sales', status: 'passed', score: 91, passThreshold: 70, timeTaken: 300 },
              { id: 3, title: 'Product Knowledge Q1', category: 'Product', status: 'pending', score: null, passThreshold: 80, timeTaken: null }
            ]
          },
          {
            userId: 102, first_name: 'James', last_name: 'Miller',
            passed: 2, failed: 2, pending: 2, passRate: 50, avgTime: 620,
            exams: [
              { id: 1, title: 'Compliance Fundamentals', category: 'Compliance', status: 'failed', score: 55, passThreshold: 75, timeTaken: 890 },
              { id: 4, title: 'Security Awareness', category: 'Security', status: 'pending', score: null, passThreshold: 70, timeTaken: null }
            ]
          },
          {
            userId: 103, first_name: 'Dani', last_name: 'Levy',
            passed: 5, failed: 0, pending: 1, passRate: 100, avgTime: 290,
            exams: [
              { id: 2, title: 'Sales Techniques Advanced', category: 'Sales', status: 'passed', score: 95, passThreshold: 70, timeTaken: 280 },
              { id: 3, title: 'Product Knowledge Q1', category: 'Product', status: 'passed', score: 88, passThreshold: 80, timeTaken: 300 }
            ]
          },
          {
            userId: 104, first_name: 'Anna', last_name: 'Katz',
            passed: 3, failed: 1, pending: 2, passRate: 75, avgTime: 450,
            exams: [
              { id: 1, title: 'Compliance Fundamentals', category: 'Compliance', status: 'passed', score: 78, passThreshold: 75, timeTaken: 600 },
              { id: 4, title: 'Security Awareness', category: 'Security', status: 'passed', score: 92, passThreshold: 70, timeTaken: 310 }
            ]
          },
          {
            userId: 105, first_name: 'Yoav', last_name: 'Ben-David',
            passed: 1, failed: 3, pending: 2, passRate: 25, avgTime: 750,
            exams: [
              { id: 1, title: 'Compliance Fundamentals', category: 'Compliance', status: 'failed', score: 48, passThreshold: 75, timeTaken: 1100 },
              { id: 2, title: 'Sales Techniques Advanced', category: 'Sales', status: 'failed', score: 62, passThreshold: 70, timeTaken: 540 }
            ]
          }
        ];
        this.q1AllUsersLoading = false;
      }, 600);
    },

    // ── Accordion toggles ───────────────────────────────
    q1ToggleExam(id) {
      this.q1ExpandedExam = this.q1ExpandedExam === id ? null : id;
    },
    q1ToggleUser(id) {
      this.q1ExpandedUser = this.q1ExpandedUser === id ? null : id;
    },

    // ── Quiz taking ─────────────────────────────────────
    async q1StartQuiz(quiz) {
      this.q1ActiveQuiz = quiz;
      const questions = await this.q1FetchQuestions(quiz.id);
      this.q1ActiveQuestions = questions;
      this.q1QIdx = 0;
      this.q1UserAnswers = questions.map(() => null);
      this.q1PastAnswers = [];
      this.q1AnswerRevealed = false;
      this.q1ShowScore = false;
      this.q1FinalScore = 0;
      this.q1TimeTaken = 0;
      this.q1DrawerMode = 'take';
      this.q1DrawerOpen = true;
      this.q1StartTime = Date.now();
      if (quiz.timeLimit && quiz.timeLimit > 0) {
        this.q1TimeLeft = quiz.timeLimit * 60;
        this.q1TimerActive = true;
        this.q1StartTimer();
      } else {
        this.q1TimerActive = false;
      }
    },

    async q1OpenResults(quiz) {
      this.q1ActiveQuiz = quiz;
      const questions = await this.q1FetchQuestions(quiz.id);
      this.q1ActiveQuestions = questions;
      // Fetch actual past answers: apiGet(`quiz/${quiz.id}/my-result`)
      this.q1PastAnswers = questions.map((q, i) => {
        // Mock: pick the correct answer index for passed, wrong for failed
        const correctIdx = q.answers.findIndex(a => a.correct);
        if (quiz.myStatus === 'passed') return correctIdx;
        return correctIdx === 0 ? 1 : 0;
      });
      this.q1DrawerMode = 'results';
      this.q1DrawerOpen = true;
    },

    q1ManagerViewResult(userRow, exam) {
      const quiz = this.q1Quizzes.find(q => q.id === exam.id);
      if (!quiz) return;
      const mockQuiz = Object.assign({}, quiz, {
        myScore: exam.score,
        myStatus: exam.score >= exam.passThreshold ? 'passed' : 'failed',
        dateTaken: exam.date || new Date().toISOString(),
        timeTaken: exam.timeTaken
      });
      this.q1OpenResults(mockQuiz);
    },

    q1SelectAnswer(answerIndex) {
      if (this.q1AnswerRevealed) return;
      this.$set(this.q1UserAnswers, this.q1QIdx, answerIndex);
      // Auto-advance after 0.5s
      this.q1AnswerRevealed = true;
      setTimeout(() => {
        if (this.q1QIdx < this.q1ActiveQuestions.length - 1) {
          this.q1QIdx++;
          this.q1AnswerRevealed = false;
        }
        // On last question, keep revealed so user can see and hit Submit
      }, 600);
    },

    q1NextQ() {
      if (this.q1QIdx < this.q1ActiveQuestions.length - 1) {
        this.q1QIdx++;
        this.q1AnswerRevealed = false;
      }
    },

    q1SubmitQuiz() {
      if (this.q1Submitting) return;
      this.q1Submitting = true;
      this.q1ClearTimer();
      this.q1TimeTaken = this.q1StartTime ? Math.round((Date.now() - this.q1StartTime) / 1000) : 0;
      const correct = this.q1CorrectCount;
      this.q1FinalScore = this.q1ActiveQuestions.length
        ? Math.round((correct / this.q1ActiveQuestions.length) * 100)
        : 0;

      const passed = this.q1FinalScore >= (this.q1ActiveQuiz ? this.q1ActiveQuiz.passThreshold : 70);

      // POST to backend: POST users/insert_to_answers_log
      apiPost('users/insert_to_answers_log', {
        exam_type: this.q1ActiveQuiz.id,
        answers: this.q1UserAnswers,
        score: this.q1FinalScore,
        time_taken: this.q1TimeTaken
      }).catch(() => {});

      // Update local state
      const quizObj = this.q1Quizzes.find(q => q.id === this.q1ActiveQuiz.id);
      if (quizObj) {
        quizObj.myScore = this.q1FinalScore;
        quizObj.myStatus = passed ? 'passed' : 'failed';
        quizObj.dateTaken = new Date().toISOString();
        quizObj.timeTaken = this.q1TimeTaken;
        if (quizObj.attemptsRemaining !== null) quizObj.attemptsRemaining = Math.max(0, quizObj.attemptsRemaining - 1);
        if (!quizObj.attempts) quizObj.attempts = [];
        quizObj.attempts.push({ score: this.q1FinalScore, timeTaken: this.q1TimeTaken, date: new Date().toISOString() });
      }

      this.q1ShowScore = true;
      this.q1Submitting = false;

      // Add Viki message
      this.q1AddVikiMessage(
        passed ? 'success' : 'warning',
        passed
          ? `Congratulations! You scored ${this.q1FinalScore}% on ${this.q1ActiveQuiz.title}.`
          : `You scored ${this.q1FinalScore}% on ${this.q1ActiveQuiz.title}. Keep studying — you can retake it.`
      );

      this.q1ShowToast(passed ? 'Passed! Great work.' : 'Quiz submitted.', passed ? '#22c55e' : '#f59e0b', passed ? 'check' : 'info');
    },

    q1ConfirmCloseDrawer() {
      if (this.q1DrawerMode === 'take' && !this.q1ShowScore && this.q1AnsweredCount > 0) {
        this.q1ConfirmExitOpen = true;
      } else {
        this.q1CloseDrawer();
      }
    },

    q1ForceCloseDrawer() {
      this.q1ConfirmExitOpen = false;
      this.q1CloseDrawer();
    },

    q1CloseDrawer() {
      this.q1ClearTimer();
      this.q1DrawerOpen = false;
      this.q1DrawerMode = 'take';
      this.q1ActiveQuiz = null;
      this.q1ActiveQuestions = [];
      this.q1ShowScore = false;
      this.q1AnswerRevealed = false;
      this.q1StartTime = null;
    },

    q1ShareResult() {
      const quiz = this.q1ActiveQuiz;
      const score = this.q1DrawerMode === 'take' ? this.q1FinalScore : (quiz ? quiz.myScore : 0);
      const passed = score >= (quiz ? quiz.passThreshold : 70);
      const msg = `I scored ${score}% on "${quiz ? quiz.title : 'Quiz'}" — ${passed ? 'PASSED' : 'FAILED'}! Time: ${this.q1FmtTimer(this.q1TimeTaken || (quiz && quiz.timeTaken) || 0)}`;
      // No viki endpoint in backend — log result locally only
      this.q1AddVikiMessage(passed ? 'success' : 'info', msg);
      this.q1ShowToast('Result shared via Viki', '#6366f1', 'info');
    },

    // ── Timer ────────────────────────────────────────────
    q1StartTimer() {
      this.q1ClearTimer();
      this.q1TimerInterval = setInterval(() => {
        if (this.q1TimeLeft > 0) {
          this.q1TimeLeft--;
        } else {
          this.q1ShowToast('Time is up! Submitting…', '#ef4444', 'x');
          this.q1SubmitQuiz();
        }
      }, 1000);
    },
    q1ClearTimer() {
      if (this.q1TimerInterval) {
        clearInterval(this.q1TimerInterval);
        this.q1TimerInterval = null;
      }
    },

    // ── Quiz builder ─────────────────────────────────────
    q1OpenCreate() {
      this.q1EditMode = false;
      this.q1EditingId = null;
      this.q1BuilderTab = 'settings';
      this.q1CreateForm = {
        title: '', description: '', category: null,
        passThreshold: 75, timeLimit: 0, maxAttempts: null,
        dueDate: '', quizStatus: 'active', questions: [],
        assignTo: 'all', assignedUsers: [], sendViki: true
      };
      this.q1CreateOpen = true;
    },

    q1OpenEdit(quiz) {
      this.q1EditMode = true;
      this.q1EditingId = quiz.id;
      this.q1BuilderTab = 'settings';
      this.q1CreateForm = {
        title: quiz.title,
        description: quiz.description || '',
        category: quiz.category,
        passThreshold: quiz.passThreshold,
        timeLimit: quiz.timeLimit || 0,
        maxAttempts: quiz.maxAttempts || null,
        dueDate: quiz.dueDate || '',
        quizStatus: quiz.quizStatus || 'active',
        questions: JSON.parse(JSON.stringify(quiz.questions || [])),
        assignTo: 'all',
        assignedUsers: [],
        sendViki: false
      };
      this.q1CreateOpen = true;
    },

    q1AddQuestion(type) {
      const q = {
        text: '',
        type: type || 'multiple_choice',
        explanation: '',
        answers: type === 'true_false'
          ? [{ text: 'True', correct: true }, { text: 'False', correct: false }]
          : [
              { text: '', correct: true },
              { text: '', correct: false },
              { text: '', correct: false },
              { text: '', correct: false }
            ]
      };
      this.q1CreateForm.questions.push(q);
    },
    q1RemoveQuestion(qi) {
      this.q1CreateForm.questions.splice(qi, 1);
    },
    q1AddAnswer(qi) {
      if (this.q1CreateForm.questions[qi].answers.length < 4) {
        this.q1CreateForm.questions[qi].answers.push({ text: '', correct: false });
      }
    },
    q1RemoveAnswer(qi, ai) {
      this.q1CreateForm.questions[qi].answers.splice(ai, 1);
    },
    q1SetCorrect(qi, ai) {
      this.q1CreateForm.questions[qi].answers.forEach((a, i) => { a.correct = i === ai; });
    },

    // Drag-to-reorder questions
    q1DragStart(idx) { this.q1DragIdx = idx; },
    q1DragOver(idx)  { this.q1DragOverIdx = idx; },
    q1DragDrop(idx)  {
      if (this.q1DragIdx === null || this.q1DragIdx === idx) return;
      const qs = this.q1CreateForm.questions;
      const moved = qs.splice(this.q1DragIdx, 1)[0];
      qs.splice(idx, 0, moved);
    },
    q1DragEnd() { this.q1DragIdx = null; this.q1DragOverIdx = null; },

    q1ToggleAssignUser(userId) {
      const idx = this.q1CreateForm.assignedUsers.indexOf(userId);
      if (idx > -1) this.q1CreateForm.assignedUsers.splice(idx, 1);
      else this.q1CreateForm.assignedUsers.push(userId);
    },

    q1SaveQuiz() {
      if (!this.q1CreateForm.title || !this.q1CreateForm.category) return;
      this.q1CreateSaving = true;

      // Backend route: POST users/insert_to_answers_log (no quiz create endpoint, saves locally)
      apiPost('users/insert_to_answers_log', { quiz: this.q1CreateForm }).catch(() => {});

      setTimeout(() => {
        if (this.q1EditMode) {
          const idx = this.q1Quizzes.findIndex(q => q.id === this.q1EditingId);
          if (idx > -1) {
            Object.assign(this.q1Quizzes[idx], {
              title: this.q1CreateForm.title,
              description: this.q1CreateForm.description,
              category: this.q1CreateForm.category,
              passThreshold: this.q1CreateForm.passThreshold,
              timeLimit: this.q1CreateForm.timeLimit || null,
              maxAttempts: this.q1CreateForm.maxAttempts || null,
              dueDate: this.q1CreateForm.dueDate || null,
              quizStatus: this.q1CreateForm.quizStatus,
              questionCount: this.q1CreateForm.questions.length,
              questions: this.q1CreateForm.questions
            });
            this.q1ShowToast('Quiz updated.', '#6366f1', 'check');
          }
        } else {
          const newQuiz = {
            id: Date.now(),
            title: this.q1CreateForm.title,
            description: this.q1CreateForm.description,
            category: this.q1CreateForm.category,
            questionCount: this.q1CreateForm.questions.length,
            timeLimit: this.q1CreateForm.timeLimit || null,
            passThreshold: this.q1CreateForm.passThreshold,
            maxAttempts: this.q1CreateForm.maxAttempts || null,
            attemptsRemaining: this.q1CreateForm.maxAttempts || null,
            dueDate: this.q1CreateForm.dueDate || null,
            myStatus: 'not_taken', myScore: null, dateTaken: null,
            quizStatus: this.q1CreateForm.quizStatus,
            avgScore: null, timeTaken: null,
            createdAt: new Date().toISOString(),
            assignedTo: this.q1CreateForm.assignTo === 'all' ? 'All agents' : 'Selected agents',
            attempts: [],
            questions: this.q1CreateForm.questions
          };
          this.q1Quizzes.push(newQuiz);
          if (this.q1CreateForm.sendViki) {
            this.q1AddVikiMessage('info', `New quiz assigned: ${newQuiz.title}`);
          }
          this.q1ShowToast('Quiz created!', '#22c55e', 'check');
        }
        this.q1CreateSaving = false;
        this.q1CreateOpen = false;
      }, 700);
    },

    q1ArchiveQuiz(quiz) {
      quiz.quizStatus = 'archived';
      this.q1ShowToast('Quiz archived.', '#6366f1', 'info');
    },

    // ── Export ───────────────────────────────────────────
    q1ExportQuizCSV(quiz) {
      const rows = [['Agent', 'Score', 'Status', 'Time', 'Date']];
      (this.q1AllUserRows || []).forEach(user => {
        const exam = user.exams.find(e => e.id === quiz.id);
        if (exam) {
          rows.push([
            `${user.first_name} ${user.last_name}`,
            exam.score !== null ? exam.score + '%' : '—',
            exam.status,
            exam.timeTaken ? this.q1FmtTimer(exam.timeTaken) : '—',
            exam.date ? this.q1FmtDate(exam.date) : '—'
          ]);
        }
      });
      this.q1DownloadCSV(`quiz-${quiz.id}-results.csv`, rows);
    },

    q1ExportTeamCSV() {
      const rows = [['Agent', 'Passed', 'Failed', 'Pending', 'Pass Rate', 'Avg Time']];
      this.q1AllUserRows.forEach(row => {
        rows.push([
          `${row.first_name} ${row.last_name}`,
          row.passed, row.failed, row.pending,
          row.passRate + '%',
          row.avgTime ? this.q1FmtTimer(row.avgTime) : '—'
        ]);
      });
      this.q1DownloadCSV('team-quiz-results.csv', rows);
    },

    q1DownloadCSV(filename, rows) {
      const csv = rows.map(r => r.map(c => `"${c}"`).join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv' });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url; a.download = filename; a.click();
      URL.revokeObjectURL(url);
    },

    // ── Settings ─────────────────────────────────────────
    q1AddCategory() {
      const val = (this.q1NewCategory || '').trim();
      if (val && !this.q1Settings.categories.includes(val)) {
        this.q1Settings.categories.push(val);
      }
      this.q1NewCategory = '';
    },
    async q1SaveSettings() {
      this.q1SettingsSaving = true;
      try {
        await this.$axios.post('/api/client/quizzes/settings', this.q1Settings, {
          headers: { Authorization: 'Bearer ' + this.$store.getters['user/token'] }
        });
        this.q1ShowToast('Settings saved', 'success');
      } catch (e) {
        // Save locally if endpoint not yet available
        this.q1ShowToast('Settings saved locally', 'success');
      } finally {
        this.q1SettingsSaving = false;
      }
    },

    // ── Calendar ─────────────────────────────────────────
    q1CalPrev() {
      if (this.q1Cal.month === 0) { this.q1Cal.month = 11; this.q1Cal.year--; }
      else this.q1Cal.month--;
    },
    q1CalNext() {
      if (this.q1Cal.month === 11) { this.q1Cal.month = 0; this.q1Cal.year++; }
      else this.q1Cal.month++;
    },

    // ── Viki ─────────────────────────────────────────────
    q1AddVikiMessage(type, text) {
      this.q1VikiMessages.unshift({ id: Date.now(), type, text, ts: new Date().toISOString(), read: false });
    },
    q1MarkVikiRead(id) {
      const msg = this.q1VikiMessages.find(m => m.id === id);
      if (msg) msg.read = true;
    },
    q1MarkAllVikiRead() {
      this.q1VikiMessages.forEach(m => { m.read = true; });
    },

    // ── Toast ────────────────────────────────────────────
    q1ShowToast(msg, color = '#6366f1', icon = 'info') {
      if (this.q1ToastTimer) clearTimeout(this.q1ToastTimer);
      this.q1Toast = { msg, color, icon };
      this.q1ToastTimer = setTimeout(() => { this.q1Toast = null; }, 2800);
    },

    // ── Filters reset ────────────────────────────────────
    q1ResetFilters() {
      this.q1Filter = {
        status: null, result: null, category: null, assigned: null,
        userId: null, due: 'all', scoreMin: 0, scoreMax: 100,
        createdFrom: '', createdTo: ''
      };
    },

    // ── Utility ──────────────────────────────────────────
    q1StatusLabel(status) {
      return { passed: 'Passed', failed: 'Failed', pending: 'Pending', not_taken: 'Not taken' }[status] || status;
    },
    q1StatusColor(status) {
      return { passed: '#22c55e', failed: '#ef4444', pending: '#f59e0b', not_taken: '#4b5563' }[status] || '#4b5563';
    },
    q1IsOverdue(dueDate) {
      if (!dueDate) return false;
      return new Date(dueDate) < new Date();
    },
    q1FmtDue(dueDate) {
      if (!dueDate) return '';
      const d = new Date(dueDate);
      const now = new Date();
      const diff = d - now;
      const days = Math.ceil(diff / 86400000);
      if (days < 0)  return Math.abs(days) + 'd overdue';
      if (days === 0) return 'Due today';
      if (days <= 7)  return 'Due in ' + days + 'd';
      return 'Due ' + d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    },
    q1FmtDate(ts) {
      if (!ts) return '—';
      return new Date(ts).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    q1FmtTime(ts) {
      if (!ts) return '';
      const d = new Date(ts);
      const now = new Date();
      const diff = Math.floor((now - d) / 1000);
      if (diff < 60)   return 'Just now';
      if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
      if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
      return this.q1FmtDate(ts);
    },
    q1FmtTimer(secs) {
      if (!secs && secs !== 0) return '—';
      const m = Math.floor(secs / 60);
      const s = secs % 60;
      return m + ':' + String(s).padStart(2, '0');
    },
    q1DonArc(part, total) {
      if (!total) return 0;
      return Math.round((part / total) * 88);
    },
    q1AgentInitials(user) {
      return (((user.first_name || '')[0]) || '').toUpperCase() +
             (((user.last_name  || '')[0]) || '').toUpperCase();
    }
  }
};
</script>

<style scoped>
/* ─── CSS VARIABLES / ROOT ───────────────────────────── */
.q1-main {
  --c1-bg:       #f4f3f0;
  --c1-surface:  #ffffff;
  --c1-surface2: #f4f3f0;
  --c1-border:   #e4e3df;
  --c1-text:     #1a1a1a;
  --c1-muted:    #64748b;
  /* Aliases so shared c1-design.css panel CSS resolves correctly */
  --c1-card:  #ffffff;
  --c1-brd:   #e4e3df;
  --c1-brd-l: #eeedea;
  --c1-t1:    #1a1a1a;
  --c1-t2:    #64748b;
  --c1-t3:    #94a3b8;
  --c1-accent:   #6366f1;
  --c1-accent2:  #8b5cf6;
  --c1-dp:       #22c55e;
  --c1-ld:       #f59e0b;
  --c1-na:       #ef4444;
  --c1-sc:       #3b82f6;
  --c1-rf:       #a855f7;
  --q1-bg:       var(--c1-bg);
  --q1-surf:     var(--c1-surface);
  --q1-surf2:    #16161f;
  --q1-brd:      var(--c1-border);
  --q1-brd-l:    #252535;
  --q1-ac:       var(--c1-accent);
  --q1-ac-low:   rgba(99,102,241,.12);
  --q1-t1:       var(--c1-text);
  --q1-t2:       #8888aa;
  --q1-t3:       #55556a;
  --q1-pass:     #22c55e;
  --q1-fail:     #ef4444;
  --q1-pend:     #f59e0b;
  font-family: 'DM Sans', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  padding-left: var(--gnm-sw, 220px);
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
@media (max-width: 767px) {
  .q1-main { padding-left: 0 !important; }
}

/* ─── TOAST ──────────────────────────────────────────── */
.qz1-toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  z-index: 99999; padding: 10px 22px; border-radius: 24px; color: #fff; font-size: .85rem; font-weight: 600;
  box-shadow: 0 4px 20px rgba(0,0,0,.25); pointer-events: none; white-space: nowrap;
  height: auto; display: inline-flex; align-items: center; gap: 6px;
}
.qz1-toast svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.qz1-toast-fade-enter-active, .qz1-toast-fade-leave-active { transition: opacity .2s, transform .2s; }
.qz1-toast-fade-enter, .qz1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ─── TOP BAR ────────────────────────────────────────── */
.q1-main .c1-tib {
  display: flex; align-items: center; gap: 2px;
  padding: 0 8px; height: 44px;
  background: var(--q1-surf); border-bottom: 1px solid var(--q1-brd);
  position: sticky; top: 0; z-index: 200; flex-shrink: 0;
}
.c1-tib-user {
  width: 30px; height: 30px; border-radius: 50%;
  background: var(--q1-ac); display: grid; place-items: center;
  cursor: pointer; position: relative; flex-shrink: 0;
}
.c1-tib-ini { font-size: 11px; font-weight: 700; color: #fff; }
.c1-tib-udot {
  width: 7px; height: 7px; border-radius: 50%; background: #4b5563;
  position: absolute; bottom: 0; right: 0; border: 1px solid var(--q1-surf);
}
.c1-tib-udot.online { background: var(--q1-pass); }
.c1-tib-badge {
  display: inline-flex; align-items: center; justify-content: center;
  width: 14px; height: 14px; border-radius: 50%;
  background: var(--q1-fail); color: #fff; font-size: 8px; font-weight: 700;
}
.c1-tib-btn {
  display: flex; align-items: center; gap: 4px;
  padding: 5px 8px; border-radius: 8px; cursor: pointer;
  font-size: 11px; font-weight: 600; color: var(--q1-t2);
  transition: all .12s; position: relative;
}
.c1-tib-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.c1-tib-btn:hover { background: var(--q1-ac-low); color: var(--q1-t1); }
.c1-tib-btn.on  { background: var(--q1-ac-low); color: var(--q1-ac); }
.c1-tib-btn.on svg { stroke: var(--q1-ac); }
.c1-hp { flex: 1; }
.q1-viki-btn { position: relative; }
.q1-viki-notif {
  position: absolute; top: 2px; right: 4px;
  background: var(--q1-fail); color: #fff; font-size: 7px; font-weight: 700;
  border-radius: 8px; padding: 1px 3px; line-height: 1;
}

/* .c1-panel-backdrop — defined globally in c1-design.css */

/* ─── PANELS (global c1-panel handles fixed sliding drawer) ────────────────────── */
.c1-panel {
  background: var(--q1-surf); border-left: 1px solid var(--q1-brd);
}
.c1-panel-hdr-bar {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 14px; border-bottom: 1px solid var(--q1-brd); flex-shrink: 0;
}
.c1-panel-hdr-bar svg { width: 14px; height: 14px; stroke: var(--q1-ac); fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; flex-shrink: 0; }
.c1-panel-hdr-ttl { font-size: 13px; font-weight: 700; color: var(--q1-t1); flex: 1; }
.c1-panel-hdr-count { font-size: 10px; font-weight: 600; color: var(--q1-ac); background: var(--q1-ac-low); padding: 2px 7px; border-radius: 10px; }
.c1-collapse-btn {
  width: 24px; height: 24px; border-radius: 6px; border: 1px solid var(--q1-brd);
  display: grid; place-items: center; cursor: pointer; color: var(--q1-t3); transition: all .12s;
}
.c1-collapse-btn:hover { border-color: var(--q1-ac); color: var(--q1-t1); }
.c1-collapse-btn svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; }

.c1-sl-body { flex: 1; overflow-y: auto; padding: 12px 14px 14px; -webkit-overflow-scrolling: touch; }
.c1-fp-group { min-width: 140px; flex: 1; }
.c1-fp-full  { width: 100%; flex: none; }
.c1-fp-lbl {
  font-size: 9px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .6px; color: var(--q1-t3); margin-bottom: 6px;
}
.c1-fp-opts { display: flex; flex-wrap: wrap; gap: 5px; }
.c1-fp-opt {
  padding: 4px 10px; border-radius: 20px; border: 1px solid var(--q1-brd);
  cursor: pointer; font-size: 11px; font-weight: 500; color: var(--q1-t2);
  background: var(--q1-surf2); transition: all .12s; white-space: nowrap;
}
.c1-fp-opt:hover { border-color: var(--q1-brd-l); color: var(--q1-t1); }
.c1-fp-opt.on { background: var(--q1-ac-low); border-color: var(--q1-ac); color: var(--q1-ac); }
.q1-status-active.on   { background: rgba(99,102,241,.12); border-color: #6366f1; color: #6366f1; }
.q1-status-draft.on    { background: rgba(245,158,11,.1);  border-color: #f59e0b; color: #f59e0b; }
.q1-status-archived.on { background: rgba(107,114,128,.1); border-color: #6b7280; color: #9ca3af; }
.q1-status-passed.on   { background: rgba(34,197,94,.12);  border-color: #22c55e; color: #22c55e; }
.q1-status-failed.on   { background: rgba(239,68,68,.12);  border-color: #ef4444; color: #ef4444; }
.q1-status-pending.on  { background: rgba(245,158,11,.12); border-color: #f59e0b; color: #f59e0b; }
.q1-status-not-taken.on{ background: rgba(99,102,241,.1);  border-color: #6366f1; color: #6366f1; }

/* Filter tabs */
.c1-ftab-menu {
  display: flex; border-bottom: 1px solid var(--q1-brd); flex-shrink: 0;
}
.c1-ftab-mi {
  flex: 1; display: flex; flex-direction: column; align-items: center; gap: 3px;
  padding: 8px 4px; cursor: pointer; font-size: 9px; font-weight: 600;
  color: var(--q1-t3); border-bottom: 2px solid transparent; transition: all .12s;
}
.c1-ftab-mi svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; }
.c1-ftab-mi:hover { color: var(--q1-t2); }
.c1-ftab-mi.on { color: var(--q1-ac); border-bottom-color: var(--q1-ac); }

/* Reset bar */
.c1-reset-bar {
  display: flex; align-items: center; gap: 6px;
  padding: 7px 14px; background: rgba(239,68,68,.08); border-bottom: 1px solid rgba(239,68,68,.2);
  cursor: pointer; font-size: 11px; color: var(--q1-fail); font-weight: 600; flex-shrink: 0;
}
.c1-reset-bar svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; }
.c1-reset-bar-count {
  background: var(--q1-fail); color: #fff; font-size: 9px; font-weight: 700;
  border-radius: 50%; width: 16px; height: 16px; display: grid; place-items: center;
}

/* Collapse bar */
.c1-collapse-bar {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 9px; border-top: 1px solid var(--q1-brd);
  cursor: pointer; font-size: 10px; font-weight: 600; color: var(--q1-t3);
  background: var(--q1-surf2); transition: all .12s; flex-shrink: 0;
}
.c1-collapse-bar:hover { background: var(--q1-brd); color: var(--q1-t1); }
.c1-collapse-bar svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2.5; }
.c1-collapse-bar-lg { padding: 12px; font-size: 11px; }

/* Agent chips */
.c1-agent-grid { display: flex; flex-wrap: wrap; gap: 6px; }
.c1-agent-chip {
  display: flex; align-items: center; gap: 5px;
  padding: 4px 8px; border-radius: 20px; border: 1px solid var(--q1-brd);
  cursor: pointer; font-size: 11px; color: var(--q1-t2); background: var(--q1-surf2);
  transition: all .12s;
}
.c1-agent-chip.on { border-color: var(--q1-ac); color: var(--q1-ac); background: var(--q1-ac-low); }
.c1-agent-av {
  width: 18px; height: 18px; border-radius: 50%; background: var(--q1-ac);
  display: grid; place-items: center; color: #fff; font-size: 8px; font-weight: 700;
}
.c1-agent-nm { font-size: 11px; }

/* Date range */
.c1-date-range-row { display: flex; align-items: center; gap: 6px; }
.c1-date-input {
  flex: 1; padding: 6px 8px; border-radius: 8px; border: 1px solid var(--q1-brd);
  background: var(--q1-surf2); color: var(--q1-t1); font-size: 11px; font-family: inherit;
}
.c1-date-input:focus { outline: none; border-color: var(--q1-ac); }
.c1-date-sep { color: var(--q1-t3); font-size: 11px; }

/* ─── SCORE RANGE FILTER ─────────────────────────────── */
.q1-score-range { display: flex; flex-direction: column; gap: 8px; }
.q1-sr-row { display: flex; align-items: center; gap: 8px; }
.q1-sr-lbl { font-size: 10px; color: var(--q1-t3); width: 24px; }
.q1-sr-val { font-size: 11px; font-weight: 700; color: var(--q1-t1); width: 32px; text-align: right; }
.q1-range-input { flex: 1; accent-color: var(--q1-ac); }

/* ─── KPI ROW ─────────────────────────────────────────── */
.c1-kpi-row { display: flex; gap: 12px; flex-wrap: wrap; }
.c1-kpi { flex: 1; min-width: 60px; }
.c1-kpi-lbl { font-size: 9px; font-weight: 600; text-transform: uppercase; letter-spacing: .5px; color: var(--q1-t3); }
.c1-kpi-val { font-size: 22px; font-weight: 800; letter-spacing: -1px; color: var(--q1-t1); line-height: 1.1; }

/* ─── DONUT ───────────────────────────────────────────── */
.q1-donut-row { display: flex; align-items: center; gap: 16px; margin-top: 6px; }
.q1-donut-inner { position: relative; width: 72px; height: 72px; flex-shrink: 0; }
.q1-donut { width: 72px; height: 72px; transform: rotate(-90deg); }
.q1-donut-center {
  position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);
  font-size: 13px; font-weight: 800; color: var(--q1-t1); pointer-events: none;
  width: 72px; text-align: center; margin-left: -36px;
}
.q1-donut-leg { display: flex; flex-direction: column; gap: 5px; }
.q1-dl-item { display: flex; align-items: center; gap: 5px; font-size: 11px; color: var(--q1-t2); }
.q1-dl-item strong { color: var(--q1-t1); font-weight: 700; }
.q1-dl-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }

/* ─── HISTOGRAM ───────────────────────────────────────── */
.q1-hist { display: flex; align-items: flex-end; gap: 4px; height: 64px; margin-top: 6px; }
.q1-hist-col { display: flex; flex-direction: column; align-items: center; gap: 3px; flex: 1; height: 100%; }
.q1-hist-bar-wrap { flex: 1; display: flex; align-items: flex-end; width: 100%; }
.q1-hist-bar { width: 100%; border-radius: 3px 3px 0 0; min-height: 2px; transition: height .4s; }
.q1-hist-lbl { font-size: 8px; color: var(--q1-t3); white-space: nowrap; }

/* ─── VBAR CHART ──────────────────────────────────────── */
.c1-vbar-chart { display: flex; flex-direction: column; gap: 5px; margin-top: 4px; }
.c1-vbar-row { display: flex; align-items: center; gap: 6px; }
.c1-vbar-lbl { font-size: 9px; color: var(--q1-t3); width: 22px; flex-shrink: 0; font-weight: 600; }
.q1-vbar-lbl-wide { width: 32px; }
.c1-vbar-track { flex: 1; height: 16px; background: var(--q1-brd); border-radius: 4px; overflow: hidden; }
.c1-vbar-fill { height: 100%; background: var(--q1-ac); border-radius: 4px; display: flex; align-items: center; padding-left: 5px; transition: width .5s; }
.q1-vbar-ac { background: var(--q1-ac) !important; }
.c1-vbar-val { font-size: 9px; color: #fff; font-weight: 600; white-space: nowrap; }

/* ─── CALENDAR ────────────────────────────────────────── */
.q1-cal-hdr { display: flex; align-items: center; justify-content: center; gap: 12px; margin-bottom: 8px; }
.q1-cal-nav {
  background: none; border: 1px solid var(--q1-brd); border-radius: 6px;
  color: var(--q1-t2); cursor: pointer; font-size: 18px;
  width: 28px; height: 28px; display: grid; place-items: center; transition: all .12s;
}
.q1-cal-nav:hover { border-color: var(--q1-ac); color: var(--q1-t1); }
.q1-cal-title { font-size: 13px; font-weight: 700; color: var(--q1-t1); min-width: 130px; text-align: center; }
.q1-cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px; }
.q1-cal-dow { text-align: center; font-size: 9px; font-weight: 700; color: var(--q1-t3); padding: 4px 0; text-transform: uppercase; }
.q1-cal-cell {
  position: relative; display: flex; flex-direction: column; align-items: center;
  justify-content: center; padding: 6px 2px; border-radius: 6px;
  font-size: 11px; color: var(--q1-t2); cursor: default; min-height: 32px;
}
.q1-cal-out { color: var(--q1-t3); opacity: .4; }
.q1-cal-today { background: var(--q1-ac-low); color: var(--q1-ac); font-weight: 700; }
.q1-cal-has-exam { background: rgba(99,102,241,.08); }
.q1-cal-due { background: rgba(245,158,11,.1); }
.q1-cal-dot { width: 4px; height: 4px; border-radius: 50%; position: absolute; bottom: 3px; }
.q1-cal-legend { display: flex; gap: 12px; margin-top: 8px; }
.q1-cl-item { display: flex; align-items: center; gap: 4px; font-size: 10px; color: var(--q1-t3); }
.q1-cl-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.q1-cal-empty { font-size: 11px; color: var(--q1-t3); padding: 8px 0; }
.q1-cal-upcoming-row {
  display: flex; align-items: center; gap: 8px; padding: 7px 0;
  border-bottom: 1px solid var(--q1-brd);
}
.q1-due-dot {
  width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;
  background: var(--q1-pend);
}
.q1-due-dot.overdue { background: var(--q1-fail); }
.q1-cal-upcoming-info { flex: 1; min-width: 0; }
.q1-cal-upcoming-title { font-size: 11px; font-weight: 600; color: var(--q1-t1); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.q1-cal-upcoming-due { font-size: 10px; color: var(--q1-t3); }
.q1-cal-upcoming-due.overdue { color: var(--q1-fail); font-weight: 600; }

/* ─── VIKI PANEL ──────────────────────────────────────── */
.q1-viki-empty { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 24px; color: var(--q1-t3); }
.q1-viki-empty svg { width: 32px; height: 32px; stroke: currentColor; fill: none; stroke-width: 1.5; opacity: .4; }
.q1-viki-msg {
  display: flex; align-items: flex-start; gap: 10px; padding: 10px 0;
  border-bottom: 1px solid var(--q1-brd); cursor: pointer; transition: background .1s;
  position: relative;
}
.q1-viki-msg:hover { background: var(--q1-surf2); border-radius: 8px; padding-left: 6px; }
.q1-viki-msg.unread { }
.q1-viki-msg-icon {
  width: 28px; height: 28px; border-radius: 50%; display: grid; place-items: center;
  flex-shrink: 0; margin-top: 1px;
}
.q1-viki-msg.success .q1-viki-msg-icon { background: rgba(34,197,94,.15); color: #22c55e; }
.q1-viki-msg.warning .q1-viki-msg-icon { background: rgba(245,158,11,.15); color: #f59e0b; }
.q1-viki-msg.info    .q1-viki-msg-icon { background: rgba(99,102,241,.15); color: #6366f1; }
.q1-viki-msg-icon svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; }
.q1-viki-msg-body { flex: 1; min-width: 0; }
.q1-viki-msg-text { font-size: 11px; color: var(--q1-t1); line-height: 1.4; }
.q1-viki-msg.unread .q1-viki-msg-text { font-weight: 600; }
.q1-viki-msg-time { font-size: 10px; color: var(--q1-t3); margin-top: 2px; }
.q1-viki-unread-dot {
  width: 6px; height: 6px; border-radius: 50%; background: var(--q1-ac);
  flex-shrink: 0; margin-top: 6px;
}
.q1-viki-mark-all {
  text-align: center; padding: 10px; font-size: 11px; font-weight: 600;
  color: var(--q1-ac); cursor: pointer; opacity: .8;
}
.q1-viki-mark-all:hover { opacity: 1; }

/* ─── PROFILE PANEL ───────────────────────────────────── */
.c1-prof-panel {
  position: fixed; top: 44px; right: 0; bottom: 0;
  width: min(340px, 100vw);
  z-index: 150; display: flex; flex-direction: column; overflow: hidden;
  transform: translateX(100%); transition: transform .25s cubic-bezier(.4,0,.2,1), box-shadow .25s;
}
.c1-prof-panel.c1-panel--open {
  transform: translateX(0); box-shadow: -4px 0 24px rgba(0,0,0,.18);
}
.q1-prof-panel { background: var(--q1-bg); }
.c1-prof-head {
  padding: 14px 16px; background: var(--q1-surf); border-bottom: 1px solid var(--q1-brd);
}
.c1-prof-brand-row { display: flex; align-items: center; margin-bottom: 12px; }
.c1-prof-brand-name { font-size: 16px; font-weight: 800; color: var(--q1-t1); }
.c1-prof-brand-name span { color: var(--q1-ac); }
.c1-prof-user-row { display: flex; align-items: center; gap: 10px; }
.c1-prof-av {
  width: 36px; height: 36px; border-radius: 50%; background: var(--q1-ac);
  display: grid; place-items: center; color: #fff; font-size: 13px; font-weight: 700;
}
.c1-prof-name { font-size: 13px; font-weight: 700; color: var(--q1-t1); }
.c1-prof-role { font-size: 10px; color: var(--q1-t3); margin-top: 1px; }
.c1-prof-scroll { background: var(--q1-bg); padding: 14px; flex: 1; overflow-y: auto; }
.c1-nc-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: var(--q1-t3); margin-bottom: 8px; }
.c1-ng { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
.c1-nb {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 7px; padding: 14px 6px 12px; border-radius: 12px; border: 1px solid var(--q1-brd);
  cursor: pointer; text-decoration: none; transition: all .12s;
  background: var(--q1-surf); color: var(--q1-t2);
}
.c1-nb:hover { border-color: var(--q1-ac); color: var(--q1-t1); }
.c1-nb svg { width: 22px; height: 22px; stroke: currentColor; fill: none; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
.c1-nb span { font-size: 10px; font-weight: 600; text-align: center; }
.c1-nb-logout { color: #ef4444; border-color: rgba(239,68,68,.3); }
.c1-nb-logout:hover { background: rgba(239,68,68,.1); border-color: #ef4444; }

/* ─── VIEW TOGGLE TABS ────────────────────────────────── */
.q1-view-tabs {
  display: flex; align-items: center; gap: 4px;
  padding: 7px 10px; background: var(--q1-surf); border-bottom: 1px solid var(--q1-brd);
  flex-shrink: 0; position: sticky; top: 44px; z-index: 100; flex-wrap: wrap;
}
.q1-vt {
  display: flex; align-items: center; gap: 6px;
  padding: 5px 10px; border-radius: 8px; cursor: pointer;
  font-size: 12px; font-weight: 600; color: var(--q1-t2);
  border: 1px solid transparent; transition: all .12s; white-space: nowrap;
}
.q1-vt svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.q1-vt:hover { color: var(--q1-t1); background: var(--q1-brd); }
.q1-vt.on { color: var(--q1-ac); background: var(--q1-ac-low); border-color: rgba(99,102,241,.3); }

/* Search bar */
.q1-search-wrap {
  display: flex; align-items: center; gap: 5px;
  padding: 4px 8px; border-radius: 8px; border: 1px solid var(--q1-brd);
  background: var(--q1-surf2); min-width: 0; max-width: 200px; flex: 1;
}
.q1-search-wrap svg { width: 12px; height: 12px; stroke: var(--q1-t3); fill: none; stroke-width: 2; flex-shrink: 0; }
.q1-search-input { flex: 1; background: none; border: none; outline: none; font-size: 11px; color: var(--q1-t1); font-family: inherit; min-width: 0; }
.q1-search-input::placeholder { color: var(--q1-t3); }
.q1-search-clear { cursor: pointer; color: var(--q1-t3); display: grid; place-items: center; }
.q1-search-clear svg { width: 11px; height: 11px; stroke: currentColor; fill: none; stroke-width: 2.5; }

.q1-add-btn {
  display: flex; align-items: center; gap: 5px; padding: 6px 12px; border-radius: 8px;
  cursor: pointer; font-size: 11px; font-weight: 600; color: #fff;
  background: var(--q1-ac); border: none; transition: opacity .12s; white-space: nowrap; flex-shrink: 0;
}
.q1-add-btn:hover { opacity: .85; }
.q1-add-btn svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2.5; }

/* ─── LOADING / EMPTY ─────────────────────────────────── */
.q1-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 48px 16px; gap: 10px; }
.q1-loading-txt { font-size: 11px; color: var(--q1-t3); }
.c1-spinner { width: 20px; height: 20px; border: 2px solid var(--q1-brd); border-top-color: var(--q1-ac); border-radius: 50%; animation: q1spin .65s linear infinite; }
@keyframes q1spin { to { transform: rotate(360deg); } }
.q1-empty { display: flex; flex-direction: column; align-items: center; padding: 48px 16px; gap: 10px; color: var(--q1-t3); }
.q1-empty svg { width: 36px; height: 36px; stroke: currentColor; fill: none; stroke-width: 1.5; opacity: .4; }
.q1-empty-msg { font-size: 13px; font-weight: 500; }

/* ─── MY SUMMARY STRIP ────────────────────────────────── */
.q1-my-summary {
  display: flex; gap: 6px; padding: 8px 0 4px;
}
.q1-my-kpi { flex: 1; background: var(--q1-surf); border: 1px solid var(--q1-brd); border-radius: 10px; padding: 8px 10px; text-align: center; }
.q1-my-kpi-val { font-size: 18px; font-weight: 800; letter-spacing: -1px; }
.q1-my-kpi-lbl { font-size: 9px; color: var(--q1-t3); font-weight: 600; text-transform: uppercase; letter-spacing: .4px; margin-top: 1px; }

/* ─── QUIZ LIST ───────────────────────────────────────── */
.q1-list { flex: 1; padding: 8px 12px 24px; display: flex; flex-direction: column; gap: 6px; overflow-y: auto; }
.q1-exam-row {
  background: var(--q1-surf); border: 1px solid var(--q1-brd);
  border-radius: 10px; overflow: hidden; transition: border-color .12s;
}
.q1-exam-row:hover { border-color: var(--q1-brd-l); }
.q1-exam-row.expanded { border-color: var(--q1-ac); }
.q1-exam-hdr {
  display: flex; align-items: center; gap: 0;
  padding: 10px 12px; cursor: pointer; position: relative; min-height: 54px;
}
.q1-exam-acc { width: 3px; height: 100%; position: absolute; left: 0; top: 0; bottom: 0; border-radius: 10px 0 0 10px; }
.q1-exam-info { flex: 1; min-width: 0; padding-left: 10px; }
.q1-exam-title { font-size: 13px; font-weight: 600; color: var(--q1-t1); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.q1-exam-meta { display: flex; align-items: center; gap: 5px; margin-top: 4px; flex-wrap: wrap; }
.q1-meta-sep { color: var(--q1-t3); }
.q1-meta-item { display: flex; align-items: center; gap: 3px; font-size: 10px; color: var(--q1-t3); }
.q1-meta-item svg { width: 10px; height: 10px; stroke: currentColor; fill: none; stroke-width: 2; }
.q1-exam-right { display: flex; align-items: center; gap: 7px; flex-shrink: 0; margin-left: 8px; }

/* Category chip */
.q1-cat-chip {
  padding: 2px 7px; border-radius: 20px; font-size: 9px; font-weight: 700;
  text-transform: uppercase; letter-spacing: .4px;
  background: var(--q1-ac-low); color: var(--q1-ac); border: 1px solid rgba(99,102,241,.2);
}
.q1-cat-chip-sm { font-size: 8px; padding: 1px 5px; }

/* Status chip */
.q1-status-chip {
  display: inline-flex; align-items: center; gap: 3px;
  padding: 2px 7px; border-radius: 20px; font-size: 10px; font-weight: 600;
}
.q1-s-passed   { background: rgba(34,197,94,.12);  color: #22c55e; }
.q1-s-failed   { background: rgba(239,68,68,.12);  color: #ef4444; }
.q1-s-pending  { background: rgba(245,158,11,.12); color: #f59e0b; }
.q1-s-not_taken{ background: rgba(99,102,241,.1);  color: #6366f1; }
.q1-s-ico { width: 10px; height: 10px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; }
.q1-s-sm { font-size: 9px; padding: 1px 5px; }

/* Score pill */
.q1-score-pill { padding: 2px 8px; border-radius: 20px; font-size: 11px; font-weight: 700; }
.q1-score-pill.pass { background: rgba(34,197,94,.12); color: #22c55e; }
.q1-score-pill.fail { background: rgba(239,68,68,.12); color: #ef4444; }
.q1-score-pill-sm { font-size: 9px; padding: 1px 5px; }

/* Due label */
.q1-due-lbl { font-size: 10px; color: var(--q1-t3); white-space: nowrap; }
.q1-due-lbl.overdue { color: #ef4444; font-weight: 600; }

/* Chevron */
.q1-chv { width: 14px; height: 14px; stroke: var(--q1-t3); fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; transition: transform .2s; flex-shrink: 0; }
.q1-chv.open { transform: rotate(180deg); }

/* Expand transition */
.q1-expand-enter-active, .q1-expand-leave-active { transition: all .2s; max-height: 600px; overflow: hidden; }
.q1-expand-enter, .q1-expand-leave-to { max-height: 0; opacity: 0; }

/* Expanded body */
.q1-exam-body { padding: 0 12px 12px 20px; border-top: 1px solid var(--q1-brd); }
.q1-exam-detail-grid { display: flex; flex-wrap: wrap; gap: 8px 14px; padding-top: 10px; }
.q1-ed-field { min-width: 100px; flex: 1; }
.q1-ed-full { width: 100%; flex: none; }
.q1-ed-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--q1-t3); margin-bottom: 2px; }
.q1-ed-val { font-size: 12px; color: var(--q1-t1); font-weight: 500; }
.q1-mono { font-family: 'JetBrains Mono', 'Courier New', monospace; }

/* Attempt history */
.q1-attempts-section { margin-top: 12px; }
.q1-attempts-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--q1-t3); margin-bottom: 6px; }
.q1-attempts-list { display: flex; flex-direction: column; gap: 4px; }
.q1-attempt-row {
  display: flex; align-items: center; gap: 8px; padding: 6px 8px;
  background: var(--q1-surf2); border-radius: 8px; border: 1px solid var(--q1-brd);
}
.q1-att-num { font-size: 10px; font-weight: 700; color: var(--q1-t3); width: 20px; }
.q1-att-score { font-size: 11px; font-weight: 700; }
.q1-att-score.pass { color: var(--q1-pass); }
.q1-att-score.fail { color: var(--q1-fail); }
.q1-att-time { font-size: 10px; color: var(--q1-t3); font-family: monospace; }
.q1-att-date { font-size: 10px; color: var(--q1-t3); flex: 1; }

/* Exam actions */
.q1-exam-actions { display: flex; gap: 8px; margin-top: 12px; flex-wrap: wrap; align-items: center; }

/* Buttons */
.q1-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 6px;
  padding: 8px 14px; border-radius: 8px; font-size: 12px; font-weight: 600;
  cursor: pointer; border: none; transition: all .12s; white-space: nowrap; font-family: inherit;
}
.q1-btn svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.q1-btn:disabled { opacity: .45; cursor: not-allowed; }
.q1-btn-take    { background: var(--q1-ac); color: #fff; }
.q1-btn-take:hover:not(:disabled)   { opacity: .9; }
.q1-btn-review  { background: var(--q1-surf2); color: var(--q1-t1); border: 1px solid var(--q1-brd); }
.q1-btn-review:hover                { border-color: var(--q1-ac); color: var(--q1-ac); }
.q1-btn-ghost   { background: none; color: var(--q1-t2); border: 1px solid var(--q1-brd); }
.q1-btn-ghost:hover:not(:disabled)  { border-color: var(--q1-brd-l); color: var(--q1-t1); }
.q1-btn-submit  { background: #22c55e; color: #fff; }
.q1-btn-submit:hover:not(:disabled) { opacity: .9; }
.q1-btn-export  { background: var(--q1-surf2); color: var(--q1-t2); border: 1px solid var(--q1-brd); }
.q1-btn-export:hover { border-color: var(--q1-brd-l); color: var(--q1-t1); }
.q1-btn-danger  { color: var(--q1-fail); border-color: rgba(239,68,68,.3); }
.q1-btn-danger:hover { background: rgba(239,68,68,.08); border-color: var(--q1-fail); }
.q1-btn-danger-solid { background: var(--q1-fail); color: #fff; }
.q1-btn-danger-solid:hover { opacity: .9; }
.q1-btn-full    { width: 100%; }
.q1-btn-sm      { padding: 4px 10px; font-size: 11px; }

/* Export bar */
.q1-export-bar { padding: 12px 0 4px; }

/* ─── ALL USERS VIEW ──────────────────────────────────── */
.q1-quiz-selector {
  background: var(--q1-surf); border: 1px solid var(--q1-brd); border-radius: 10px;
  padding: 10px 12px; margin-bottom: 6px;
}
.q1-qs-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--q1-t3); margin-bottom: 6px; }
.q1-qs-chips { display: flex; flex-wrap: wrap; gap: 5px; }
.q1-qs-chip {
  padding: 3px 9px; border-radius: 20px; font-size: 10px; font-weight: 600;
  border: 1px solid var(--q1-brd); color: var(--q1-t2); background: var(--q1-surf2);
  cursor: pointer; transition: all .12s;
}
.q1-qs-chip:hover { border-color: var(--q1-brd-l); color: var(--q1-t1); }
.q1-qs-chip.on { background: var(--q1-ac-low); border-color: var(--q1-ac); color: var(--q1-ac); }

.q1-team-summary {
  display: flex; gap: 8px; padding: 10px 12px;
  background: var(--q1-surf); border: 1px solid var(--q1-brd); border-radius: 10px; margin-bottom: 4px;
}
.q1-ts-kpi { flex: 1; text-align: center; }
.q1-ts-val { font-size: 20px; font-weight: 800; letter-spacing: -1px; }
.q1-ts-lbl { font-size: 9px; color: var(--q1-t3); font-weight: 600; text-transform: uppercase; letter-spacing: .4px; }

.q1-user-block { background: var(--q1-surf); border: 1px solid var(--q1-brd); border-radius: 10px; overflow: hidden; }
.q1-user-block-hdr { display: flex; align-items: center; gap: 10px; padding: 10px 12px; cursor: pointer; transition: background .1s; }
.q1-user-block-hdr:hover { background: var(--q1-surf2); }
.q1-ub-av { width: 32px; height: 32px; border-radius: 50%; background: var(--q1-ac); display: grid; place-items: center; color: #fff; font-size: 12px; font-weight: 700; flex-shrink: 0; }
.q1-ub-info { flex: 1; min-width: 0; }
.q1-ub-name { font-size: 13px; font-weight: 600; color: var(--q1-t1); }
.q1-ub-meta { display: flex; gap: 5px; font-size: 10px; color: var(--q1-t3); margin-top: 2px; flex-wrap: wrap; }
.q1-ub-sep { color: var(--q1-t3); }
.q1-ub-pass { color: var(--q1-pass); font-weight: 600; }
.q1-ub-pending { color: var(--q1-pend); }
.q1-ub-rate { font-weight: 600; color: var(--q1-t1); }
.q1-ub-time { color: var(--q1-t3); }
.q1-ub-time-pill { font-size: 9px; color: var(--q1-t3); background: var(--q1-surf2); border: 1px solid var(--q1-brd); border-radius: 10px; padding: 1px 6px; }
.q1-ub-prog-wrap { flex-shrink: 0; display: flex; flex-direction: column; align-items: flex-end; gap: 2px; }
.q1-ub-prog-track { width: 60px; height: 4px; background: var(--q1-brd); border-radius: 2px; overflow: hidden; }
.q1-ub-prog-fill { height: 100%; background: var(--q1-pass); border-radius: 2px; transition: width .4s; }
.q1-ub-prog-lbl { font-size: 9px; color: var(--q1-t3); font-weight: 600; }

.q1-ub-exams { border-top: 1px solid var(--q1-brd); padding: 6px 10px; display: flex; flex-direction: column; gap: 4px; }
.q1-ub-exam-row { display: flex; align-items: center; gap: 6px; padding: 5px 0; }
.q1-ub-exam-title { font-size: 11px; color: var(--q1-t2); flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.q1-ub-review-btn {
  background: none; border: 1px solid var(--q1-brd); border-radius: 6px; padding: 3px;
  cursor: pointer; color: var(--q1-t3); display: grid; place-items: center; transition: all .12s;
}
.q1-ub-review-btn:hover { border-color: var(--q1-ac); color: var(--q1-ac); }
.q1-ub-review-btn svg { width: 11px; height: 11px; stroke: currentColor; fill: none; stroke-width: 2; }

/* ─── SCOREBOARD ──────────────────────────────────────── */
.q1-scoreboard {
  background: var(--q1-surf); border: 1px solid var(--q1-brd); border-radius: 10px; overflow: hidden;
}
.q1-sb-hdr {
  display: flex; align-items: center; gap: 8px; padding: 8px 14px;
  background: var(--q1-surf2); border-bottom: 1px solid var(--q1-brd);
  font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--q1-t3);
}
.q1-sb-row {
  display: flex; align-items: center; gap: 8px; padding: 10px 14px;
  border-bottom: 1px solid var(--q1-brd); transition: background .1s;
}
.q1-sb-row:last-child { border-bottom: none; }
.q1-sb-row:hover { background: var(--q1-surf2); }
.q1-sb-top.q1-sb-rank-1 { background: rgba(255,215,0,.05); }
.q1-sb-top.q1-sb-rank-2 { background: rgba(192,192,192,.05); }
.q1-sb-top.q1-sb-rank-3 { background: rgba(205,127,50,.05); }
.q1-sb-rank { width: 28px; flex-shrink: 0; }
.q1-sb-rank-num { font-size: 11px; color: var(--q1-t3); font-weight: 700; }
.q1-sb-medal {
  width: 22px; height: 22px; border-radius: 50%; display: grid; place-items: center;
  font-size: 10px; font-weight: 800; color: #000;
}
.q1-sb-medal.gold   { background: #FFD700; }
.q1-sb-medal.silver { background: #C0C0C0; }
.q1-sb-medal.bronze { background: #CD7F32; }
.q1-sb-name { flex: 1; min-width: 0; display: flex; align-items: center; gap: 8px; }
.q1-sb-av {
  width: 26px; height: 26px; border-radius: 50%; background: var(--q1-ac);
  display: grid; place-items: center; color: #fff; font-size: 10px; font-weight: 700; flex-shrink: 0;
}
.q1-sb-name span { font-size: 12px; font-weight: 600; color: var(--q1-t1); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.q1-sb-score { width: 70px; flex-shrink: 0; }
.q1-sb-time { width: 50px; flex-shrink: 0; font-size: 11px; color: var(--q1-t3); }
.q1-sb-attempts { width: 50px; flex-shrink: 0; font-size: 11px; color: var(--q1-t3); text-align: center; }
.q1-sb-status { flex-shrink: 0; }

/* ─── QUIZ TAKING DRAWER ──────────────────────────────── */
.q1-drawer-wrap {
  position: fixed; inset: 0; background: rgba(0,0,0,.7);
  z-index: 400; display: flex; justify-content: flex-end;
}
.q1-drawer {
  width: min(500px, 100vw); height: 100%; background: var(--q1-surf);
  border-left: 1px solid var(--q1-brd); display: flex; flex-direction: column;
  overflow: hidden;
}
.q1-create-drawer {
  border-left: none; border-right: 1px solid var(--q1-brd);
}
.q1-ldrawer-wrap { justify-content: flex-start; }

.q1-drawer-enter-active, .q1-drawer-leave-active { transition: transform .25s cubic-bezier(.4,0,.2,1); }
.q1-drawer-enter, .q1-drawer-leave-to { transform: translateX(100%); }
.q1-ldrawer-enter-active, .q1-ldrawer-leave-active { transition: transform .25s cubic-bezier(.4,0,.2,1); }
.q1-ldrawer-enter, .q1-ldrawer-leave-to { transform: translateX(-100%); }
.q1-fade-enter-active, .q1-fade-leave-active { transition: opacity .15s; }
.q1-fade-enter, .q1-fade-leave-to { opacity: 0; }

.q1-dr-head {
  padding: 14px 16px 12px; border-bottom: 1px solid var(--q1-brd); flex-shrink: 0;
  display: flex; flex-wrap: wrap; align-items: flex-start; gap: 3px; position: relative;
  background: var(--q1-surf2);
}
.q1-dr-title { font-size: 15px; font-weight: 700; color: var(--q1-t1); width: 100%; padding-right: 34px; }
.q1-dr-sub { font-size: 11px; color: var(--q1-t3); display: flex; align-items: center; gap: 4px; }
.q1-dr-sub svg { width: 11px; height: 11px; stroke: currentColor; fill: none; stroke-width: 2; }
.q1-q-counter { font-size: 12px; font-weight: 600; color: var(--q1-t2); }
.q1-dr-close {
  position: absolute; top: 12px; right: 12px;
  width: 28px; height: 28px; border-radius: 6px; border: 1px solid var(--q1-brd);
  background: none; color: var(--q1-t2); cursor: pointer; display: grid; place-items: center; transition: all .12s;
}
.q1-dr-close:hover { border-color: var(--q1-ac); color: var(--q1-t1); }
.q1-dr-close svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }

/* Progress bar */
.q1-progress-track { height: 3px; background: var(--q1-brd); flex-shrink: 0; }
.q1-progress-fill { height: 100%; background: var(--q1-ac); transition: width .35s; }

/* Question dots nav */
.q1-q-dots {
  display: flex; gap: 3px; padding: 8px 16px; flex-shrink: 0;
  background: var(--q1-surf2); border-bottom: 1px solid var(--q1-brd);
  flex-wrap: wrap;
}
.q1-q-dot {
  width: 10px; height: 10px; border-radius: 50%;
  background: var(--q1-brd); transition: all .2s;
}
.q1-q-dot.current  { background: var(--q1-ac); transform: scale(1.3); }
.q1-q-dot.answered { background: var(--q1-pass); }
.q1-q-dot.skipped  { background: var(--q1-pend); }

/* Timer */
.q1-timer { font-family: 'JetBrains Mono', 'Courier New', monospace; font-size: 12px; font-weight: 700; color: var(--q1-t2); display: inline-flex; align-items: center; gap: 3px; }
.q1-timer svg { width: 11px; height: 11px; stroke: currentColor; fill: none; stroke-width: 2; }
.q1-timer.urgent { color: #ef4444; animation: q1pulse 1s infinite; }
@keyframes q1pulse { 0%,100% { opacity:1; } 50% { opacity:.4; } }

.q1-dr-body { flex: 1; overflow-y: auto; padding: 16px 16px 8px; -webkit-overflow-scrolling: touch; }
.q1-dr-foot { padding: 12px 16px; border-top: 1px solid var(--q1-brd); display: flex; align-items: center; gap: 8px; flex-shrink: 0; background: var(--q1-surf2); }
.q1-foot-left { display: flex; align-items: center; }
.q1-foot-answered { font-size: 10px; color: var(--q1-t3); }

/* Question block */
.q1-q-wrap { margin-bottom: 16px; }
.q1-q-number { font-size: 10px; font-weight: 700; color: var(--q1-ac); margin-bottom: 6px; text-transform: uppercase; letter-spacing: .5px; }
.q1-q-text { font-size: 15px; font-weight: 600; color: var(--q1-t1); line-height: 1.5; }
.q1-q-type-badge {
  display: inline-block; margin-top: 6px; padding: 2px 8px; border-radius: 20px;
  font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px;
  background: rgba(99,102,241,.1); color: var(--q1-ac); border: 1px solid rgba(99,102,241,.2);
}

/* MC answers */
.q1-answers { display: flex; flex-direction: column; gap: 8px; }
.q1-ans-opt {
  display: flex; align-items: center; gap: 10px; padding: 12px 14px;
  border-radius: 10px; border: 1px solid var(--q1-brd); cursor: pointer;
  background: var(--q1-surf2); color: var(--q1-t1); transition: all .15s; position: relative;
}
.q1-ans-opt:hover:not(.selected):not(.correct):not(.wrong):not(.disabled) { border-color: var(--q1-ac); background: var(--q1-ac-low); }
.q1-ans-opt.selected { border-color: var(--q1-ac); background: var(--q1-ac-low); }
.q1-ans-opt.correct  { border-color: #22c55e; background: rgba(34,197,94,.1); cursor: default; }
.q1-ans-opt.wrong    { border-color: #ef4444; background: rgba(239,68,68,.08); cursor: default; }
.q1-ans-opt.disabled { cursor: default; }
.q1-ans-letter {
  width: 24px; height: 24px; border-radius: 50%; border: 1px solid var(--q1-brd);
  display: grid; place-items: center; font-size: 11px; font-weight: 700; flex-shrink: 0; color: var(--q1-t2);
}
.q1-ans-opt.selected .q1-ans-letter { background: var(--q1-ac);  border-color: var(--q1-ac);  color: #fff; }
.q1-ans-opt.correct  .q1-ans-letter { background: #22c55e;        border-color: #22c55e;        color: #fff; }
.q1-ans-opt.wrong    .q1-ans-letter { background: #ef4444;        border-color: #ef4444;        color: #fff; }
.q1-ans-text { flex: 1; font-size: 13px; line-height: 1.4; }
.q1-ans-ico { width: 16px; height: 16px; stroke: currentColor; fill: none; stroke-width: 2.5; flex-shrink: 0; }
.q1-ans-ico.correct { color: #22c55e; }
.q1-ans-ico.wrong   { color: #ef4444; }

/* T/F answers */
.q1-tf-answers { display: flex; gap: 10px; }
.q1-tf-opt {
  flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;
  padding: 20px 10px; border-radius: 12px; border: 2px solid var(--q1-brd);
  cursor: pointer; background: var(--q1-surf2); font-size: 14px; font-weight: 700; color: var(--q1-t2);
  transition: all .15s;
}
.q1-tf-opt svg { width: 24px; height: 24px; stroke: currentColor; fill: none; stroke-width: 2.5; }
.q1-tf-opt:hover:not(.selected):not(.correct):not(.wrong) { border-color: #22c55e; color: #22c55e; background: rgba(34,197,94,.08); }
.q1-tf-false:hover:not(.selected):not(.correct):not(.wrong) { border-color: #ef4444; color: #ef4444; background: rgba(239,68,68,.06); }
.q1-tf-opt.selected { border-color: var(--q1-ac); color: var(--q1-ac); background: var(--q1-ac-low); }
.q1-tf-opt.correct  { border-color: #22c55e; color: #22c55e; background: rgba(34,197,94,.1); cursor: default; }
.q1-tf-opt.wrong    { border-color: #ef4444; color: #ef4444; background: rgba(239,68,68,.08); cursor: default; }

/* Explanation box */
.q1-explanation {
  margin-top: 14px; padding: 12px 14px; border-radius: 10px;
  background: rgba(99,102,241,.08); border: 1px solid rgba(99,102,241,.2);
}
.q1-exp-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--q1-ac); margin-bottom: 4px; }
.q1-exp-text { font-size: 12px; color: var(--q1-t2); line-height: 1.5; }
.q1-exp-sm { margin-top: 8px; padding: 8px 10px; }

/* ─── SCORE SCREEN ────────────────────────────────────── */
.q1-score-screen { display: flex; flex-direction: column; align-items: center; padding-top: 20px; }
.q1-score-circle {
  width: 120px; height: 120px; border-radius: 50%; border: 4px solid var(--q1-brd);
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  margin-bottom: 14px;
}
.q1-score-circle.pass { border-color: #22c55e; background: rgba(34,197,94,.08); }
.q1-score-circle.fail { border-color: #ef4444; background: rgba(239,68,68,.06); }
.q1-sc-pct { font-size: 28px; font-weight: 800; color: var(--q1-t1); letter-spacing: -1px; line-height: 1; }
.q1-sc-lbl { font-size: 10px; font-weight: 700; letter-spacing: 1px; margin-top: 3px; }
.q1-score-circle.pass .q1-sc-lbl { color: #22c55e; }
.q1-score-circle.fail .q1-sc-lbl { color: #ef4444; }

.q1-score-banner {
  width: 100%; padding: 10px 16px; border-radius: 10px; text-align: center;
  font-size: 13px; font-weight: 600; margin-bottom: 14px;
}
.q1-score-banner.pass { background: rgba(34,197,94,.1); color: #22c55e; }
.q1-score-banner.fail { background: rgba(239,68,68,.08); color: #ef4444; }

.q1-score-stats-grid {
  display: grid; grid-template-columns: repeat(4,1fr); gap: 8px; width: 100%; margin-bottom: 16px;
}
.q1-ss-item { background: var(--q1-surf2); border: 1px solid var(--q1-brd); border-radius: 10px; padding: 10px 6px; text-align: center; }
.q1-ss-val { font-size: 18px; font-weight: 800; color: var(--q1-t1); letter-spacing: -1px; line-height: 1.1; }
.q1-ss-lbl { font-size: 9px; color: var(--q1-t3); font-weight: 600; text-transform: uppercase; letter-spacing: .4px; margin-top: 2px; }

.q1-wrong-section { width: 100%; margin-top: 4px; }
.q1-wrong-hdr {
  display: flex; align-items: center; gap: 7px; padding: 8px 0; margin-bottom: 8px;
  font-size: 12px; font-weight: 700; color: var(--q1-pend); border-bottom: 1px solid var(--q1-brd);
}
.q1-wrong-hdr svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }

.q1-score-actions { display: flex; gap: 8px; width: 100%; margin-top: 16px; }

/* ─── RESULTS REVIEW ──────────────────────────────────── */
.q1-res-summary { display: flex; flex-direction: column; align-items: center; margin-bottom: 16px; }
.q1-review-list { display: flex; flex-direction: column; gap: 10px; }
.q1-rev-q { background: var(--q1-surf2); border: 1px solid var(--q1-brd); border-radius: 10px; overflow: hidden; }
.q1-rev-q-hdr { display: flex; align-items: flex-start; gap: 8px; padding: 10px 12px; }
.q1-rev-num { flex-shrink: 0; font-size: 9px; font-weight: 700; color: var(--q1-t3); padding-top: 2px; width: 20px; }
.q1-rev-text { flex: 1; font-size: 12px; font-weight: 600; color: var(--q1-t1); line-height: 1.4; }
.q1-rev-ico { width: 16px; height: 16px; stroke: currentColor; fill: none; stroke-width: 2.5; flex-shrink: 0; margin-top: 1px; }
.q1-rev-ico.correct { color: #22c55e; }
.q1-rev-ico.wrong   { color: #ef4444; }
.q1-rev-answers { padding: 0 12px 10px; display: flex; flex-direction: column; gap: 4px; }
.q1-rev-ans {
  display: flex; align-items: center; gap: 7px; padding: 7px 10px; border-radius: 8px;
  font-size: 11px; color: var(--q1-t3); background: var(--q1-surf); border: 1px solid transparent;
  position: relative;
}
.q1-rev-ans.correct  { color: #22c55e; border-color: rgba(34,197,94,.2);  background: rgba(34,197,94,.07); }
.q1-rev-ans.selected { color: #ef4444; border-color: rgba(239,68,68,.2);  background: rgba(239,68,68,.06); }
.q1-rev-correct-tag, .q1-rev-your-tag {
  margin-left: auto; font-size: 9px; font-weight: 700; padding: 1px 6px; border-radius: 10px;
}
.q1-rev-correct-tag { background: rgba(34,197,94,.15); color: #22c55e; }
.q1-rev-your-tag    { background: rgba(239,68,68,.12); color: #ef4444; }

/* ─── BUILDER DRAWER ──────────────────────────────────── */
.q1-builder-tabs {
  display: flex; border-bottom: 1px solid var(--q1-brd); flex-shrink: 0; background: var(--q1-surf2);
}
.q1-bt {
  flex: 1; display: flex; align-items: center; justify-content: center; gap: 5px;
  padding: 9px 6px; cursor: pointer; font-size: 11px; font-weight: 600; color: var(--q1-t3);
  border-bottom: 2px solid transparent; transition: all .12s; position: relative;
}
.q1-bt svg { width: 13px; height: 13px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.q1-bt:hover { color: var(--q1-t2); }
.q1-bt.on { color: var(--q1-ac); border-bottom-color: var(--q1-ac); }
.q1-bt-badge {
  background: var(--q1-ac); color: #fff; font-size: 8px; font-weight: 700;
  border-radius: 8px; padding: 1px 4px;
}

/* Form elements */
.q1-form-group { margin-bottom: 12px; }
.q1-form-lbl { display: block; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--q1-t3); margin-bottom: 5px; }
.q1-form-input {
  width: 100%; padding: 8px 10px; border-radius: 8px; border: 1px solid var(--q1-brd);
  background: var(--q1-bg); color: var(--q1-t1); font-size: 12px; font-family: inherit;
  transition: border-color .12s; box-sizing: border-box;
}
.q1-form-input:focus { outline: none; border-color: var(--q1-ac); }
.q1-form-input::placeholder { color: var(--q1-t3); }
.q1-form-textarea { resize: vertical; min-height: 60px; }
.q1-form-row3 { display: flex; gap: 10px; }
.q1-form-row3 .q1-form-group { flex: 1; min-width: 0; }

.q1-qs-hdr { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.q1-qs-hdr-btns { display: flex; gap: 6px; }
.q1-no-questions {
  text-align: center; padding: 24px; font-size: 12px; color: var(--q1-t3);
  border: 1px dashed var(--q1-brd); border-radius: 10px; margin-bottom: 12px;
}
.q1-create-q {
  background: var(--q1-surf2); border: 1px solid var(--q1-brd); border-radius: 10px;
  padding: 10px; margin-bottom: 8px; transition: border-color .12s;
}
.q1-create-q:hover { border-color: var(--q1-brd-l); }
.q1-create-q.dragging { border-color: var(--q1-ac); opacity: .7; }
.q1-cq-hdr { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; }
.q1-cq-drag-handle {
  cursor: grab; color: var(--q1-t3); display: flex; align-items: center; padding: 2px;
}
.q1-cq-drag-handle:active { cursor: grabbing; }
.q1-cq-drag-handle svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }
.q1-cq-type-badge {
  padding: 2px 6px; border-radius: 6px; font-size: 8px; font-weight: 800; text-transform: uppercase;
  background: var(--q1-ac-low); color: var(--q1-ac); letter-spacing: .5px; flex-shrink: 0;
}
.q1-cq-input { flex: 1; }
.q1-cq-del {
  background: none; border: none; color: var(--q1-t3); cursor: pointer;
  padding: 4px; display: grid; place-items: center; border-radius: 6px; transition: all .12s;
}
.q1-cq-del:hover { color: #ef4444; background: rgba(239,68,68,.1); }
.q1-cq-del svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2; }
.q1-cq-answers { display: flex; flex-direction: column; gap: 4px; }
.q1-cq-ans-row { display: flex; align-items: center; gap: 6px; }
.q1-cq-radio { accent-color: var(--q1-ac); flex-shrink: 0; cursor: pointer; width: 14px; height: 14px; }
.q1-cq-ans-letter {
  width: 20px; height: 20px; border-radius: 50%; border: 1px solid var(--q1-brd);
  display: grid; place-items: center; font-size: 9px; font-weight: 700; color: var(--q1-t3); flex-shrink: 0;
}
.q1-cq-ans-input { flex: 1; }
.q1-cq-ans-del {
  background: none; border: none; color: var(--q1-t3); cursor: pointer; padding: 2px;
  display: grid; place-items: center; border-radius: 4px; transition: all .12s;
}
.q1-cq-ans-del:hover { color: #ef4444; }
.q1-cq-ans-del svg { width: 11px; height: 11px; stroke: currentColor; fill: none; stroke-width: 2.5; }
.q1-cq-tf-lbl { font-size: 12px; font-weight: 600; color: var(--q1-t2); }
.q1-cq-exp-row { margin-top: 8px; padding-top: 8px; border-top: 1px solid var(--q1-brd); }

/* ─── CONFIRM EXIT MODAL ──────────────────────────────── */
.q1-modal-wrap {
  position: fixed; inset: 0; background: rgba(0,0,0,.7); z-index: 500;
  display: flex; align-items: center; justify-content: center; padding: 20px;
}
.q1-modal {
  background: var(--q1-surf); border: 1px solid var(--q1-brd); border-radius: 14px;
  padding: 20px; max-width: 320px; width: 100%;
}
.q1-modal-title { font-size: 15px; font-weight: 700; color: var(--q1-t1); margin-bottom: 8px; }
.q1-modal-body { font-size: 12px; color: var(--q1-t2); line-height: 1.5; margin-bottom: 16px; }
.q1-modal-actions { display: flex; gap: 8px; justify-content: flex-end; }

/* ─── RESPONSIVE ──────────────────────────────────────── */
@media (max-width: 480px) {
  .q1-drawer { width: 100vw; }
  .q1-exam-right { gap: 4px; }
  .q1-due-lbl { display: none; }
  .q1-form-row3 { flex-direction: column; }
  .q1-score-stats-grid { grid-template-columns: repeat(2,1fr); }
  .q1-team-summary { flex-wrap: wrap; gap: 10px; }
  .q1-my-kpi-val { font-size: 14px; }
  .q1-scoreboard .q1-sb-time,
  .q1-scoreboard .q1-sb-attempts { display: none; }
  .q1-view-tabs { gap: 3px; }
  .q1-search-wrap { max-width: 120px; }
  .c1-ng { grid-template-columns: repeat(2, 1fr); }
  .q1-set-grid { grid-template-columns: 1fr; }
  .q1-set-row { flex-direction: column; align-items: flex-start; gap: 8px; }
  .q1-set-ctrl { align-self: flex-start; }
}

/* ─── SETTINGS ────────────────────────────────────────── */
.q1-settings-wrap { display: flex; flex-direction: column; gap: 0; overflow-y: auto; }
.q1-set-section {
  padding: 20px 20px 0;
  border-bottom: 1px solid var(--q1-brd);
  margin-bottom: 0;
}
.q1-set-section:last-of-type { border-bottom: none; }
.q1-set-section-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 13px; font-weight: 700; color: var(--q1-t1);
  margin-bottom: 14px;
}
.q1-set-section-title svg { width: 15px; height: 15px; stroke: var(--q1-purple); fill: none; stroke-width: 2; }
.q1-set-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 0;
}
.q1-set-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 0; border-bottom: 1px solid var(--q1-brd); gap: 16px;
}
.q1-set-row:last-child { border-bottom: none; }
.q1-set-row.q1-set-row-col { grid-column: 1 / -1; flex-direction: column; align-items: flex-start; gap: 10px; }
.q1-set-lbl { display: flex; flex-direction: column; gap: 2px; }
.q1-set-lbl-name { font-size: 13px; font-weight: 600; color: var(--q1-t1); }
.q1-set-lbl-hint { font-size: 11px; color: var(--q1-t3); }
.q1-set-ctrl { display: flex; align-items: center; flex-shrink: 0; }
.q1-set-num-wrap {
  display: flex; align-items: center; gap: 0;
  border: 1.5px solid var(--q1-brd); border-radius: 8px; overflow: hidden;
  background: var(--q1-bg);
}
.q1-set-num {
  width: 58px; padding: 7px 10px; border: none; outline: none;
  background: transparent; color: var(--q1-t1); font-size: 14px; font-weight: 600;
  text-align: center;
}
.q1-set-unit {
  padding: 7px 10px; background: var(--q1-surf); color: var(--q1-t3);
  font-size: 12px; font-weight: 600; border-left: 1.5px solid var(--q1-brd);
}
.q1-set-toggle {
  width: 42px; height: 24px; border-radius: 12px; background: var(--q1-brd);
  position: relative; cursor: pointer; transition: background .2s;
}
.q1-set-toggle.on { background: var(--q1-purple); }
.q1-set-toggle-knob {
  position: absolute; top: 3px; left: 3px;
  width: 18px; height: 18px; border-radius: 50%; background: #fff;
  transition: left .2s; box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
.q1-set-toggle.on .q1-set-toggle-knob { left: 21px; }
.q1-set-textarea {
  width: 100%; padding: 10px 12px; border: 1.5px solid var(--q1-brd); border-radius: 8px;
  background: var(--q1-bg); color: var(--q1-t1); font-size: 13px; resize: vertical;
  outline: none; font-family: inherit; line-height: 1.5;
}
.q1-set-textarea:focus { border-color: var(--q1-purple); }
.q1-set-input {
  flex: 1; padding: 8px 12px; border: 1.5px solid var(--q1-brd); border-radius: 8px;
  background: var(--q1-bg); color: var(--q1-t1); font-size: 13px; outline: none;
}
.q1-set-input:focus { border-color: var(--q1-purple); }
.q1-cat-mgr { width: 100%; display: flex; flex-direction: column; gap: 10px; }
.q1-cat-list { display: flex; flex-wrap: wrap; gap: 8px; }
.q1-cat-item { display: flex; align-items: center; gap: 4px; }
.q1-cat-del {
  width: 18px; height: 18px; border-radius: 50%; border: none; background: rgba(239,68,68,.12);
  color: #ef4444; cursor: pointer; display: grid; place-items: center; padding: 0;
}
.q1-cat-del svg { width: 10px; height: 10px; stroke: currentColor; fill: none; stroke-width: 2.5; }
.q1-cat-add-row { display: flex; gap: 8px; align-items: center; }
.q1-btn-sm { padding: 7px 14px; font-size: 12px; }
.q1-btn-purple { background: var(--q1-purple); color: #fff; border: none; }
.q1-btn-purple:hover { background: #6a48f2; }
.q1-set-actions {
  padding: 20px; display: flex; justify-content: flex-end;
  border-top: 1px solid var(--q1-brd);
}

/* Hide sliding panel — replaced by inline top-strip */
.c1-quiz-page .c1-panel { display: none !important; }
</style>
